webpackJsonp([3],[
/* 0 */,
/* 1 */,
/* 2 */
/*!**********************************!*\
  !*** ./client/services/array.js ***!
  \**********************************/
/*! exports provided: isArray, arrayIncludes, arrayLoop, arrayRandom */
/*! exports used: arrayIncludes, arrayLoop, isArray */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayIncludes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arrayLoop; });
/* unused harmony export arrayRandom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_includes__ = __webpack_require__(/*! array-includes */ 67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_array_includes__);




// @function arrayLoop(array, callback)
// Easily loop through arrays, objects and numbers
//
// @param {array|object|number} array – The iterable item
// @param {arrayLoop~callback} callback – Each item is iterated through
//
// @callback arrayLoop~callback
// @param {number|string} index – For objects this is the key, for arrays/number this is the index
// @param {string|object} value – For objects this is the object, for arrays this is the array item, for numbers this is the index
function arrayLoop(array, callback) {
  var isNum = typeof array === 'number';
  if (Array.isArray(array) || isNum) {
    var length = isNum ? array : array.length;
    for (var i = 0; i < length; i++) {
      callback(i, isNum ? i : array[i]);
    }
  } else if (typeof array === 'object') {
    Object.keys(array).forEach(function (i) {
      callback(i, array[i]);
    });
  } else {
    console.warn('Not an object', array);
  }
}

// isArray(array)
var isArray = function isArray(array) {
  return Array.isArray(array);
};

function arrayRandom(array) {
  return array[Math.floor(Math.random() * array.length)];
}

function arrayIncludes(array, check) {
  return __WEBPACK_IMPORTED_MODULE_0_array_includes___default()(array, check);
}



/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/*!**************************!*\
  !*** ./client/config.js ***!
  \**************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  name: "VeriTooth",
  rootUrl: "https://app.veritooth.com",
  openGraph: "https://app.veritooth.com/og.jpg",
  meta: {
    separator: " \u2013 "
  },
  transitionDuration: 300,
  gtag: {
    scriptSource: "https://www.googletagmanager.com/gtag/js",
    gtagId: "UA-137817635-1"
  },
  stripe_publishable_key:  false ? // eslint-disable-line no-undef
  "pk_live_ePrkHuYMwLMOG6N4e2ocF74D00hLs6KvuZ" : "pk_test_4MQbQMZLPP4JQW1QxlvkcFh700Qd3L0U1m"
};

var apiMap = {
  local: "http://localhost:8000/api",
  dev: "https://backend-dev.veritooth.com/api",
  qa: "https://backend-qa.veritooth.com/api",
  prod: "https://admin.veritooth.com/api"
};

var wpMap = {
  local: "http://veritooth.t29dev.com",
  dev: "http://veritooth.t29dev.com",
  qa: "http://veritooth.t29dev.com",
  prod: "https://veritooth.com"
};

var envMap = {
  qa: "qa",
  production: "prod",
  development: "dev",
  local: "local"
};

var env = envMap["development"] || "dev"; // eslint-disable-line no-undef

/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, config, {
  env: env,
  api: apiMap[env],
  wp: wpMap[env]
}));

/***/ }),
/* 7 */
/*!********************************************!*\
  !*** ./client/components/modules/Link.vue ***!
  \********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Link.vue */ 88),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-aadab054"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Link.vue */ 89),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/*!********************************************!*\
  !*** ./client/components/modules/Icon.vue ***!
  \********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Icon.vue */ 62),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3768dcd5"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Icon.vue */ 63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */
/*!**********************************************!*\
  !*** ./client/components/modules/Button.vue ***!
  \**********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Button.vue */ 82),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7298420e"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Button.vue */ 85),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/*!********************************!*\
  !*** ./client/router/index.js ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_store__ = __webpack_require__(/*! store */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_config__ = __webpack_require__(/*! config */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_gtag_js__ = __webpack_require__(/*! ../services/gtag.js */ 22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_auth__ = __webpack_require__(/*! ../models/auth */ 17);
// Vue



// Vuex


// Config


// Services



// Async load function that handles loading
var loadAsyncPage = function loadAsyncPage(pageImport) {
  var init = __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].state.app.state.init;

  __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('app/openLoader');

  return new Promise(function (resolve) {

    pageImport.then(function (component) {
      setTimeout(function () {

        if (!init) {
          __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('app/init');
        }
      }, __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].state.app.state.init ? 0 : __WEBPACK_IMPORTED_MODULE_3_config__["a" /* default */].transitionDuration);

      resolve(component);
    });
  });
};

// Base
var NotFound = function NotFound() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/404 */ 176)));
};

// Top Level Pages
var Home = function Home() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Home */ 177)));
};
var Terms = function Terms() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Terms */ 178)));
};
var InfoDentists = function InfoDentists() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/InfoDentists */ 179)));
};
var InfoReviewers = function InfoReviewers() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/InfoReviewers */ 180)));
};
var UnderstandingYourReport = function UnderstandingYourReport() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/UnderstandingYourReport */ 181)));
};
var TrackLink = function TrackLink() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/TrackLink */ 182)));
};

// Auth
var Login = function Login() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Login */ 183)));
};
var Logout = function Logout() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Logout */ 184)));
};
var RegisterDentist = function RegisterDentist() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/register/RegisterDentist */ 185)));
};
var RegisterPatient = function RegisterPatient() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/register/RegisterPatient */ 186)));
};
var AuthReset = function AuthReset() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/auth/Reset */ 187)));
};
var AuthConfirm = function AuthConfirm() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/auth/Confirm */ 188)));
};

// Dashboard
var Dashboard = function Dashboard() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Dashboard */ 189)));
};
var DashboardProfileMyInfo = function DashboardProfileMyInfo() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/profile/MyInfo */ 190)));
};
var DashboardProfilePassword = function DashboardProfilePassword() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/profile/Password */ 191)));
};
var DashboardRequests = function DashboardRequests() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/Requests */ 192)));
};
var DashboardReviews = function DashboardReviews() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/Reviews */ 193)));
};
var DashboardReview = function DashboardReview() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/Review */ 194)));
};
var DashboardDentistLocations = function DashboardDentistLocations() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/profile/Locations */ 195)));
};
var DashboardReviewerApplication = function DashboardReviewerApplication() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/ReviewerApplication */ 196)));
};
var DashboardReviewerRequests = function DashboardReviewerRequests() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/ReviewerRequests */ 197)));
};
var DashboardReviewerRequest = function DashboardReviewerRequest() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/ReviewerRequest */ 198)));
};
var DashboardEmailLogs = function DashboardEmailLogs() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/EmailLogs */ 199)));
};
var DashboardEmailActivity = function DashboardEmailActivity() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/dashboard/EmailActivity */ 200)));
};

// Success
var Success = function Success() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Success */ 201)));
};

// Request
var Request = function Request() {
  return loadAsyncPage(__webpack_require__.e/* import() */(0/*! page-base */).then(__webpack_require__.bind(null, /*! views/Request */ 202)));
};

// Payment Request
var ReviewPaymentRequest = function ReviewPaymentRequest() {
  return loadAsyncPage(__webpack_require__.e/* import() */(1/*! review-payment-request */).then(__webpack_require__.bind(null, /*! views/ReviewPaymentRequest */ 203)));
};

// Use
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// Routes
var routes = [{
  path: '*',
  name: 'notFound',
  component: NotFound
}, {
  path: '/',
  name: 'home',
  component: Home
}, {
  path: '/terms-of-service',
  name: 'terms',
  component: Terms
}, {
  path: '/privacy-policy',
  name: 'privacy',
  component: Terms
}, {
  path: '/link/:payload/:redirect',
  name: 'track-link',
  component: TrackLink
},

// Auth
{
  name: 'login',
  path: '/log-in',
  component: Login,
  meta: {
    noAuth: true
  }
}, {
  name: 'logout',
  path: '/log-out',
  component: Logout,
  meta: {
    noFooter: true
  }
}, {
  name: 'register-dentist',
  path: '/register/dentist',
  component: RegisterDentist,
  meta: {
    noAuth: true
  }
}, {
  name: 'register-reviewer',
  path: '/register/reviewer',
  component: RegisterDentist,
  meta: {
    noAuth: true
  }
}, {
  name: 'register-patient',
  path: '/register/patient',
  component: RegisterPatient,
  meta: {
    noAuth: true
  }
}, {
  name: 'authReset',
  path: '/password/forgot',
  component: AuthReset,
  meta: {
    noAuth: true
  }
}, {
  path: '/reset-password/:token',
  redirect: function redirect(to) {
    var params = to.params;

    if (params.token) {
      return { name: 'authConfirm', params: { token: params.token } };
    }
  }
}, {
  name: 'authConfirm',
  path: '/password/reset/:token',
  component: AuthConfirm,
  meta: {
    noAuth: true
  }
}, {
  name: 'set-password',
  path: '/set-password/:token',
  component: AuthConfirm,

  beforeEnter: function beforeEnter(to, from, next) {
    var userAuthed = __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/isAuthenticated'];
    if (userAuthed) {
      __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/requestLogout', {
        noRedirect: true
      });
    }
    return next();
  }
}, {
  name: 'understanding-your-report',
  path: '/understanding-your-report',
  component: UnderstandingYourReport
},

// Info
{
  name: 'info-dentists',
  path: '/dentists',
  component: InfoDentists
}, {
  name: 'info-reviewers',
  path: '/reviewers',
  component: InfoReviewers
},

// Request
{
  name: 'request',
  path: '/request',
  component: Request,
  meta: {
    auth: [1]
  }
}, {
  name: 'request-complete',
  path: '/request/:id',
  component: Request,
  meta: {
    auth: [1, 2, 3]
  }
}, {
  name: 'success',
  path: '/success/:page',
  component: Success,
  meta: {
    auth: true
  }
}, {
  name: 'review-payment-request',
  path: '/review/payment/:id',
  component: ReviewPaymentRequest,
  meta: {
    auth: true
  }
}, {
  name: 'dashboard-next-review',
  path: '/dashboard/review',
  component: DashboardReview,
  meta: {
    key: 'dashboard',
    auth: [3]
  }
},

// Dashboard
{
  name: 'dashboard',
  path: '/dashboard',
  component: Dashboard,
  meta: {
    key: 'dashboard'
  },
  children: [
  // Admin
  {
    name: 'admin-email-logs',
    path: 'email-logs',
    component: DashboardEmailLogs,
    meta: {
      key: 'dashboard',
      auth: [42]
    }
  }, {
    name: 'admin-email-activity',
    path: 'email-activity/:id',
    component: DashboardEmailActivity,
    meta: {
      key: 'dashboard',
      auth: [42]
    }
  }, {
    name: 'admin-reviewer-requests',
    path: 'reviewer-requests',
    component: DashboardReviewerRequests,
    meta: {
      key: 'dashboard',
      auth: [42]
    }
  }, {
    name: 'admin-reviewer-request',
    path: 'reviewer-request/:id',
    component: DashboardReviewerRequest,
    meta: {
      key: 'dashboard',
      auth: [42]
    }
  },
  // Review
  {
    name: 'dashboard-requests',
    path: 'requests',
    component: DashboardRequests,
    meta: {
      key: 'dashboard',
      auth: true
    }
  }, {
    name: 'dashboard-reviews',
    path: 'reviews',
    component: DashboardReviews,
    meta: {
      key: 'dashboard',
      auth: [3]
    }
  }, {
    name: 'dashboard-review',
    path: 'request/:id',
    component: DashboardReview,
    meta: {
      key: 'dashboard',
      auth: [1, 2, 3, 42]
    }
  },

  // Profile
  {
    name: 'dashboard-profile-info',
    path: 'profile',
    component: DashboardProfileMyInfo,
    meta: {
      key: 'dashboard',
      auth: true
    }
  }, {
    name: 'dashboard-profile-password',
    path: 'profile/password',
    component: DashboardProfilePassword,
    meta: {
      key: 'dashboard',
      auth: true
    }
  },

  // Dentist
  {
    name: 'dashboard-dentist-locations',
    path: 'profile/locations',
    component: DashboardDentistLocations,
    meta: {
      key: 'dashboard',
      auth: true
    }
  },
  // Reviewer
  {
    name: 'dashboard-reviewer-application',
    path: 'reviewer-application',
    component: DashboardReviewerApplication,
    meta: {
      key: 'dashboard',
      auth: [2]
    }
  }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  var meta = to.meta;

  var auth = meta.auth || [];
  var isNoAuth = meta.noAuth === true;

  var userAuthed = __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/isAuthenticated'];
  var auth_token = localStorage.getItem('auth_token'); // eslint-disable-line no-unused-vars

  // If show tour is active and user deviates away unset the tour
  var userOnTour = __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/showTour'];

  var role = __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/userRole'] || {};

  var userFollowingTour = function userFollowingTour() {
    var tourPath = __WEBPACK_IMPORTED_MODULE_5__models_auth__["h" /* tourPaths */][userOnTour] || [];
    var upcomingTourLocation = tourPath.indexOf(to.name);
    var previousTourLocation = tourPath.indexOf(from.name);

    if (to.name === 'dashboard') {
      // Ignore for now
      return true;
    }

    if (upcomingTourLocation === -1) {
      return false;
    }

    if (upcomingTourLocation === 0) {
      // Tour just started
      return true;
    }

    if (upcomingTourLocation - 1 === previousTourLocation) {
      // Is previous location immediately preceding current?
      return true;
    }

    return false; // gotta catch 'em all
  };

  if (userOnTour && __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/userIsRole']([2]) && !userFollowingTour()) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/deactivateTour');
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__services_gtag_js__["b" /* logPageView */])(to.path);

  // Handle a user coming directly to a `modal-path` link
  if (to.query['modal-path']) {
    next({
      path: '/' + to.query['modal-path']
    });
    return false;
  }

  // Handle closing an open modal from the current route
  if (to.name === from.name && (from.query.modal || from.query['modal-path'])) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('modals/closeModal');
    return false;
  }

  // Handle initial authentication
  if (!userAuthed && auth_token) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/storeRedirect', to.path);
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/requestCurrentUser', {
      auth_token: auth_token,
      redirect: true
    });
    return false;
  }

  if (to.name === 'set-password' && to.query.redirect) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/storeRedirect', to.query.redirect);
  }

  if (to.name.match(/^register-(patient|dentist|reviewer)$/) && to.query.redirect) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/storeRedirect', to.query.redirect);
  }

  // Handle states that require auth for unauthed users
  if ((auth === true || auth.length) && !userAuthed) {
    __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('auth/storeRedirect', to.path);
    next({
      name: 'login',
      query: {
        redirect: to.path
      }
    });
    return false;
  }

  // Handle pages that a user doesn't have permission to view
  // Ensure that the page that is being redirected to doesn't have any
  // specific permissions (it can be a page that requires default auth though)
  var roleObject = role.object || {};

  if (auth.length && !__WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/userIsRole'](auth) && userAuthed || to.name === 'dashboard' && userAuthed) {

    // Go to dashboard-profile-info if they just signed up
    if (!!__WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/showTour'] && to.name === 'dashboard' && __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].getters['auth/userIsRole']([2])) {
      // Is there any user data at this point or not?
      next({
        name: 'dashboard-profile-info'
      });
      return false;
    }

    next({
      name: roleObject.defaultRoute || 'dashboard-profile-info'
    });
    return false;
  }

  // Handle states that require no auth for authed users
  if (isNoAuth && userAuthed) {
    next({
      name: roleObject.defaultRoute || 'dashboard-profile-info'
    });
    return false;
  }

  next();

  if (to.query.modal) {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_2_store__["a" /* default */].dispatch('modals/openModal', to.query.modal);
    }, 500);
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/*!***************************************!*\
  !*** ./client/components/ui/Auth.vue ***!
  \***************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Auth.vue */ 65),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-33153b5f"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Auth.vue */ 118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/*!*************************************!*\
  !*** ./client/models/auth/index.js ***!
  \*************************************/
/*! exports provided: _forms, login, registerPatient, registerDentist, reset, confirm, resetPassword, tourPaths */
/*! exports used: _forms, confirm, login, registerDentist, registerPatient, reset, resetPassword, tourPaths */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _forms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return registerPatient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return registerDentist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return confirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return resetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return tourPaths; });
var _forms = {
  title: {
    login: "Sign in to VeriTooth"
  },
  copy: {
    login: ""
  },
  actions: {
    login: "requestLogin",
    registerPatient: "requestRegisterPatient",
    registerDentist: "requestRegisterDentist",
    reset: "requestResetPassword",
    confirm: "requestConfirmPassword"
  },
  submit: {
    login: "Sign In",
    register: "Create Account",
    register_dentist: "Create Account",
    reset: "Request Reset",
    confirm: "Set Password"
  }
};

var login = {
  email: {
    label: "Email Address",
    labelHidden: true,
    type: "email",
    errorLabel: "Email",
    placeholder: "Enter your Email",
    autoComplete: "user email",
    validations: {
      required: true,
      email: true
    }
  },
  password: {
    label: "Password",
    labelHidden: true,
    type: "password",
    autoComplete: "current-password",
    placeholder: "Enter your Password",
    validations: {
      required: true
    },
    forgot: true
  }
};

var registerPatient = {
  first_name: {
    type: "text",
    label: "First Name",
    labelHidden: true,
    placeholder: "First Name",
    autoComplete: "given-name",
    validations: {
      required: true
    }
  },
  last_name: {
    type: "text",
    label: "Last Name",
    labelHidden: true,
    placeholder: "Last Name",
    autoComplete: "family-name",
    validations: {
      required: true
    }
  },
  email: {
    label: "Email",
    labelHidden: true,
    placeholder: "Email",
    autoComplete: "user email",
    type: "email",
    errorLabel: "Email",
    validations: {
      required: true,
      email: true
    }
  },
  password: {
    label: "Password",
    labelHidden: true,
    placeholder: "Create Password",
    helper: true,
    autoComplete: "new-password",
    type: "password",
    validations: {
      required: true,
      min: 6
    }
  },
  confirmPassword: {
    label: "Confirm Password",
    labelHidden: true,
    placeholder: "Confirm Password",
    type: "password",
    autoComplete: "new-password",
    validations: {
      required: true,
      min: 6,
      match: "password"
    },
    errorMessages: {
      match: "Passwords do not match"
    }
  }
};

var registerDentist = {
  specialty: {
    type: "select",
    items: [],
    label: "Select Your Speciality",
    labelHidden: true,
    placeholder: "Select Your Speciality",
    validations: {
      required: true
    }
  },
  first_name: {
    type: "text",
    label: "First Name",
    labelHidden: true,
    placeholder: "First Name",
    validations: {
      required: true
    }
  },
  last_name: {
    type: "text",
    label: "Last Name",
    labelHidden: true,
    placeholder: "Last Name",
    validations: {
      required: true
    }
  },
  email: {
    label: "Email Address",
    labelHidden: true,
    placeholder: "Email Address",
    autoComplete: "user email",
    type: "email",
    errorLabel: "Email",
    validations: {
      required: true,
      email: true
    }
  },
  password: {
    label: "Password",
    labelHidden: true,
    placeholder: "Create Password",
    helper: true,
    autoComplete: "password",
    type: "password",
    validations: {
      required: true,
      min: 6
    }
  },
  confirmPassword: {
    label: "Confirm Password",
    labelHidden: true,
    placeholder: "Confirm Password",
    type: "password",
    autoComplete: "new-password",
    validations: {
      required: true,
      min: 6,
      match: "password"
    },
    errorMessages: {
      match: "Passwords do not match"
    }
  }
};

var reset = {
  email: {
    type: "email",
    label: "Email Address",
    labelHidden: true,
    errorLabel: "Email",
    placeholder: "Enter your Email",
    validations: {
      required: true,
      email: true
    }
  }
};

var confirm = {
  new_password: {
    label: "Password",
    labelHidden: true,
    type: "password",
    placeholder: "Enter your Password",
    validations: {
      required: true,
      min: 6
    }
  },
  confirm_password: {
    label: "Confirm",
    labelHidden: true,
    type: "password",
    placeholder: "Enter your Password",
    validations: {
      required: true,
      min: 6,
      match: "new_password"
    }
  }
};

var resetPassword = {
  current_password: {
    label: "Current Password",
    labelHidden: true,
    placeholder: "Enter current password",
    type: "password",
    autoComplete: "current-password",
    heading: {
      heading: "Current Password",
      level: "h4"
    },
    validations: {
      required: true
    },
    forgot: true
  },
  new_password: {
    heading: {
      heading: "New Password",
      level: "h4",
      tag: "h3"
    },
    label: "New Password",
    labelHidden: true,
    helper: true,
    type: "password",
    placeholder: "New Password",
    autoComplete: "new-password",
    validations: {
      required: true,
      min: 6
    }
  },
  confirmPassword: {
    label: "Confirm Password",
    labelHidden: true,
    placeholder: "Confirm Password",
    type: "password",
    autoComplete: "new-password",
    validations: {
      required: true,
      min: 6,
      match: "new_password"
    },
    errorMessages: {
      match: "Passwords do not match"
    }
  }
};

var tourPaths = {
  dentist: ["dashboard-profile-info", "dashboard-dentist-locations"],
  reviewer: ["dashboard-profile-info", "dashboard-dentist-locations", "dashboard-reviewer-application"]
};

/***/ }),
/* 18 */
/*!***********************************************!*\
  !*** ./client/services/scroll.js + 1 modules ***!
  \***********************************************/
/*! exports provided: destroyScroll, createScroll */
/*! exports used: createScroll, destroyScroll */
/*! ModuleConcatenation bailout: Cannot concat with ./client/services/array.js because of ./client/index.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./client/services/array.js
var array = __webpack_require__(2);

// CONCATENATED MODULE: ./client/services/numbers.js


var toFixedNumber = function toFixedNumber(number, x) {
  var base = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;

  var pow = Math.pow(base, x);
  return +(Math.round(number * pow) / pow);
};

function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (bytes === 0) {
    return '0 Bytes';
  }

  var k = 1024;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
}


// CONCATENATED MODULE: ./client/services/scroll.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return destroyScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createScroll; });


// Services




var windowY = 0;
var scrollY = 0;
var ticking = false;

var scroll_elements = {};

var destroyScroll = function destroyScroll(id) {
  scroll_elements[id] = null;
};

var scroll_doScroll = function doScroll() {
  Object(array["b" /* arrayLoop */])(scroll_elements, function (id, item) {
    if (item === null) return;

    var hasMove = typeof item.move === 'function';
    var hasEnter = typeof item.enter === 'function';
    var hasLeave = typeof item.leave === 'function';

    if (!hasMove && !hasEnter && !hasLeave) return;

    var args = {
      scrollY: scrollY
    };

    if (item.el) {
      var rect = item.el.getBoundingClientRect() || {};

      args.top = {
        top: rect.top,
        topPercent: toFixedNumber(rect.top / windowY * -100, 2),
        bottom: rect.top - windowY
      };

      args.bottom = {
        bottom: rect.bottom
      };

      if (hasEnter) {
        var enterProps = item.enterProps || {};
        var enterTrigger = !enterProps.trigger || typeof enterProps.trigger !== 'number' ? 66.66 : enterProps.trigger;
        var enterTriggerY = windowY / 100 * enterTrigger;

        args.enter = args.top.top <= enterTriggerY;
      }
    }

    if (hasMove) {
      item.move(args);
    }

    if (hasEnter && args.enter) {
      item.enter(args);
      destroyScroll(id);
    }

    if (item.debug) {
      console.log(id, args); // eslint-disable-line no-console
    }
  });
};

var initScroll = function initScroll() {
  scrollY = window.scrollY;
  windowY = window.innerHeight;

  if (ticking) return false;

  window.requestAnimationFrame(function () {
    scroll_doScroll();
    ticking = false;
  });

  ticking = true;
};

var createScroll = function createScroll(id, args) {
  if (typeof id !== 'string') {
    console.error('id must be a string');
    return false;
  }

  scroll_elements[id] = args;
  scroll_doScroll();
};

window.removeEventListener('scroll', initScroll, false);
window.addEventListener('scroll', initScroll, false);
window.addEventListener('load', initScroll(), false);

/***/ }),
/* 19 */
/*!********************************************!*\
  !*** ./client/components/modules/Logo.vue ***!
  \********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Logo.vue */ 114),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-478305f2"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Logo.vue */ 117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */
/*!*********************************************!*\
  !*** ./client/services/gtag.js + 1 modules ***!
  \*********************************************/
/*! exports provided: injectGtag, logPageView */
/*! exports used: injectGtag, logPageView */
/*! ModuleConcatenation bailout: Cannot concat with ./client/config.js because of ./client/index.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./client/services/dom.js
var isScriptLoaded = function isScriptLoaded(scriptSource) {
  var scriptWithSource = document.querySelector("script[src='" + scriptSource + "']");
  return !!scriptWithSource;
};
// EXTERNAL MODULE: ./client/config.js
var config = __webpack_require__(6);

// CONCATENATED MODULE: ./client/services/gtag.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gtag_injectGtag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logPageView; });



var gtagSource = config["a" /* default */].gtag.scriptSource;
var gtagId = config["a" /* default */].gtag.gtagId;

var gtag_injectGtag = function injectGtag() {
  var headTag = document.querySelector('head');
  var scriptAlreadyLoaded = isScriptLoaded(gtagSource);
  var isPrd = config["a" /* default */].env === 'prod';
  if (headTag && !scriptAlreadyLoaded && isPrd) {
    var gtagLibScriptElement = document.createElement('script');
    gtagLibScriptElement.setAttribute('async', '');
    gtagLibScriptElement.setAttribute('src', gtagSource + '?id=' + gtagId);
    headTag.prepend(gtagLibScriptElement);
  }
};

var logPageView = function logPageView(path) {
  if (typeof window.gtag !== 'function') {
    return false;
  }

  window.gtag('config', gtagId, { 'page_path': path });
  return true;
};

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/*!*********************************!*\
  !*** ./client/services/link.js ***!
  \*********************************/
/*! exports provided: getLinkType, getLinkTag, createLinkProps */
/*! exports used: createLinkProps, getLinkTag, getLinkType */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLinkType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinkTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLinkProps; });


var getLinkType = function getLinkType(link) {
  var type = 'router-link';

  if (!link) {
    type = 'button';
  } else if (/^((f|ht)tps?:\/\/|mailto:)/i.test(link)) {
    type = 'a';
  } else if (typeof link === 'string' && link.charAt(0) === '#') {
    type = 'anchor';
  }

  return type;
};

var getLinkTag = function getLinkTag(link) {
  var linkType = getLinkType(link);

  return linkType === 'anchor' ? 'a' : linkType;
};

var createLinkProps = function createLinkProps(link) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var linkType = getLinkType(link);

  var isEmail = /^mailto:/i.test(link);
  var titleSuffix = '';

  if (linkType === 'a') {
    titleSuffix = '(opens ' + (isEmail ? 'native email client' : 'in new tab') + ')';
  }

  if (linkType === 'anchor') {
    titleSuffix = '(scrolls to ' + link + ')';
  }

  if (!title) {
    title = '' + label + (label && titleSuffix ? ' ' : '') + titleSuffix;
  }

  var props = {
    title: title || false
  };

  if (linkType === 'a' || linkType === 'anchor') {
    props.href = link;
    if (options.query && Object.entries(options.query).length) {
      try {
        var url = new URL(link);
        var searchParams = url.searchParams;
        for (var param in options.query) {
          searchParams.append(param, options.query[param]);
        }
        props.href = url.href;
      } catch (e) {
        var _searchParams = new URLSearchParams();
        for (var _param in options.query) {
          _searchParams.append(_param, options.query[_param]);
        }
        props.href += _searchParams.toString();
      }
    }
  }

  if (['a', 'router-link', 'anchor'].includes(linkType) && options.external === true || linkType === 'a' && !isEmail) {
    props.target = '_blank';
  }

  if (linkType === 'router-link') {
    props.to = link.name ? link : { name: link };
    if (options.query && Object.entries(options.query).length) {
      props.to.query = options.query;
    }
  }

  return props;
};

/***/ }),
/* 34 */
/*!********************************************!*\
  !*** ./client/store/index.js + 18 modules ***!
  \********************************************/
/*! exports provided: default */
/*! exports used: default */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vue/dist/vue.runtime.esm.js (<- Module uses injected variables (global, setImmediate)) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// EXTERNAL MODULE: ./client/config.js
var config = __webpack_require__(6);

// CONCATENATED MODULE: ./client/store/app.js


// Config



// Vue


// State
var app_state = {
  env: config["a" /* default */].env,
  page: {
    classes: '',
    name: '',
    params: {},
    meta: {},
    query: {}
  },
  state: {
    init: false,
    loading: true,
    loaded: false
  },
  viewport: {
    height: null,
    width: null
  },
  touch: null
};

// Getters
var app_getters = {
  appEnv: function appEnv(state) {
    return state.env;
  },
  appState: function appState(state) {
    return state.state;
  },
  appPage: function appPage(state) {
    return state.page;
  },
  viewportHeight: function viewportHeight(state) {
    return state.viewport.height;
  },
  viewportWidth: function viewportWidth(state) {
    return state.viewport.width;
  },
  viewportMobile: function viewportMobile(state) {
    return state.viewport.width < 768;
  },
  touch: function touch(state) {
    return state.touch === null ? null : !!state.touch;
  }
};

// Mutations
var mutations = {
  SET_PAGE: function SET_PAGE(state, page) {
    state.page = page;
  },
  SET_STATE: function SET_STATE(state) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!key) return;

    vue_runtime_esm["a" /* default */].set(state.state, key, true);
  },
  UNSET_STATE: function UNSET_STATE(state) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (!key) return;

    vue_runtime_esm["a" /* default */].set(state.state, key, false);
  },
  UPDATE_VIEWPORT: function UPDATE_VIEWPORT(state, viewport) {
    state.viewport.height = viewport[0];
    state.viewport.width = viewport[1];
  },
  SET_TOUCH: function SET_TOUCH(state, touch) {
    state.touch = touch;
  }
};

// Actions
var actions = {
  init: function init(_ref) {
    var commit = _ref.commit;

    commit('SET_STATE', 'init');
    commit('UNSET_STATE', 'loading');

    setTimeout(function () {
      commit('SET_STATE', 'loaded');
      commit('UNSET_STATE', 'intro');
    }, config["a" /* default */].transitionDuration);
  },
  updatePage: function updatePage(_ref2) {
    var commit = _ref2.commit,
        rootState = _ref2.rootState;

    var route = rootState.route;
    var classes = 'page--' + route.name;

    commit('SET_PAGE', {
      name: route.name,
      params: route.params,
      meta: route.meta,
      query: route.query,
      classes: classes
    });
  },
  openLoader: function openLoader(_ref3) {
    var commit = _ref3.commit;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (payload.isIntro) {
      commit('SET_STATE', 'intro');
    }
    commit('SET_STATE', 'loading');

    setTimeout(function () {
      commit('UNSET_STATE', 'loaded');
    }, config["a" /* default */].transitionDuration);
  },
  closeLoader: function closeLoader(_ref4) {
    var commit = _ref4.commit;

    commit('UNSET_STATE', 'loading');

    window.scrollTo(0, 0); // TODO: Fix on back button

    setTimeout(function () {
      commit('SET_STATE', 'loaded');
    }, config["a" /* default */].transitionDuration);
  },
  updateViewport: function updateViewport(_ref5) {
    var commit = _ref5.commit;

    clearTimeout(window.updateViewport);

    // WHY: Debounces the update to only fire after all has been resized
    window.updateViewport = setTimeout(function () {
      commit('UPDATE_VIEWPORT', [window.innerHeight, window.innerWidth]);
    }, 100);
  },
  setTouch: function setTouch(_ref6) {
    var commit = _ref6.commit;

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints; // WHY: https://stackoverflow.com/a/4819886/2599650

    commit('SET_TOUCH', isTouch);
  }
};

// Export
/* harmony default export */ var app = ({
  namespaced: true,
  state: app_state,
  getters: app_getters,
  mutations: mutations,
  actions: actions
});
// EXTERNAL MODULE: ./client/services/array.js
var array = __webpack_require__(2);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(131);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./client/services/string.js
var string = __webpack_require__(45);

// CONCATENATED MODULE: ./client/services/forms.js



// Services
/* eslint-disable import/no-extraneous-dependencies */



function setValidation(key, field) {
  var validations = {};

  var fieldType = field.type || 'text';
  var isTextField = Object(array["a" /* arrayIncludes */])(['text', 'textarea', 'url', 'email', 'password'], fieldType);

  var fieldValidations = field.validations;

  if (!fieldValidations) {
    return validations;
  }

  var vMax = fieldValidations.max || 0;
  var vMin = fieldValidations.min || 0;

  var map = {
    required: validators["required"],
    email: validators["email"],
    url: validators["url"],
    min: Object(validators["minValue"])(vMin),
    max: Object(validators["maxValue"])(vMax),
    match: Object(validators["sameAs"])(fieldValidations.match || '')
  };

  Object(array["b" /* arrayLoop */])(map, function (i) {
    if (fieldValidations[i]) {
      if (i === 'min' && isTextField) {
        validations.minLength = Object(validators["minLength"])(vMin);
      } else if (i === 'max' && isTextField) {
        validations.maxLength = Object(validators["maxLength"])(vMax);
      } else {
        validations[i] = map[i];
      }
    }
  });

  return validations;
}

function createFieldObject(_ref) {
  var args = _ref.args,
      type = _ref.type,
      stringify = _ref.stringify;

  var setType = args.textType || type || 'text';

  var obj = {
    label: args.label || ''
  };

  if (setType !== 'text') {
    obj.type = setType;
  }

  var hasValidations = false;
  var validations = {};

  if (args.noLabel) {
    obj.noLabel = true;
  }

  var contentType = args.contentType;
  if (contentType && contentType !== 'String') {
    obj.contentType = args.contentType;
  }

  if (setType === 'textarea') {
    if (args.resize) {
      obj.resize = true;
    }
    if (args.rows) {
      obj.rows = args.rows;
    }
  }

  if (Object(array["a" /* arrayIncludes */])(['radio', 'checkbox', 'select'], type)) {
    var items = args.items || [];

    /* eslint-disable unicorn/explicit-length-check */
    if (!items.length && args.options) {
      var options = ['A', 'B', 'C', 'D'];

      Object(array["b" /* arrayLoop */])(args.options, function (i) {
        items.push({
          option: 'Option ' + options[i],
          value: contentType === 'Number' ? i + 1 : '' + options[i].toLowerCase()
        });
      });
    }
    obj.items = items;
  }

  Object(array["b" /* arrayLoop */])(['email', 'url'], function (index, key) {
    if (setType === key) {
      validations[key] = true;
      hasValidations = true;
    }
  });

  if (args.required) {
    validations.required = true;
    hasValidations = true;
  }

  Object(array["b" /* arrayLoop */])(['min', 'max'], function (index, key) {
    if (args[key]) {
      validations[key] = args[key];
      hasValidations = true;
    }
  });

  if (hasValidations) {
    obj.validations = validations;
  }

  return stringify ? Object(string["b" /* stringifyObject */])(obj) : obj;
}


// CONCATENATED MODULE: ./client/store/forms.js
// Vue


// Services



// State
var forms_state = {};

// Getters
var forms_getters = {
  getForm: function getForm(state) {
    return function (slug) {
      return state[slug] || {};
    };
  },
  getModel: function getModel(state) {
    return function (slug) {
      var model = {};
      var form = state[slug] || {};

      Object(array["b" /* arrayLoop */])(form.model || {}, function (i, v) {
        var val = v;
        if (v === '_NULL') {
          val = null;
        } else if (v === '0') {
          val = 0;
        }
        model[i] = val;
      });

      return model;
    };
  },
  getStatus: function getStatus(state) {
    return function (slug) {
      return (state[slug] || {}).status || {};
    };
  },
  getValidations: function getValidations(state) {
    return function (slug) {
      return (state[slug] || {}).validations || {};
    };
  },
  getServerErrors: function getServerErrors(state) {
    return function (slug) {
      return (state[slug] || {}).serverErrors || {};
    };
  }
};

// Mutations
var forms_mutations = {
  // TODO: Rename with
  createFormObject: function createFormObject(state, payload) {
    vue_runtime_esm["a" /* default */].set(state, payload.id, payload.obj);
  },
  updateValue: function updateValue(state, payload) {
    vue_runtime_esm["a" /* default */].set(state[payload.form].model, payload.field, payload.value);
  },
  updateValid: function updateValid(state, payload) {
    vue_runtime_esm["a" /* default */].set(state[payload.form], 'valid', payload.value);
  },
  TOGGLE_VALIDATION: function TOGGLE_VALIDATION(state, payload) {
    vue_runtime_esm["a" /* default */].set(state[payload.form].validations, payload.key, setValidation(payload.key, payload.value ? payload.field : {}));
  },
  updateFieldValidation: function updateFieldValidation(state, payload) {
    vue_runtime_esm["a" /* default */].set(state[payload.form].validations, payload.key, setValidation(payload.key, payload.field));
  },
  updateStatus: function updateStatus(state, payload) {
    vue_runtime_esm["a" /* default */].set(state[payload.form].status, payload.status, payload.value);
  },
  updateServerError: function updateServerError(state, payload) {
    // Set a field-specific or global server error
    vue_runtime_esm["a" /* default */].set(state[payload.form].serverErrors, payload.field || '_global', payload.error || '');
    // If unsetting it, also unset the global error message to
    if (!payload.error) {
      vue_runtime_esm["a" /* default */].set(state[payload.form].serverErrors, '_global', '');
    }
  },
  resetForm: function resetForm(state, payload) {
    if (state[payload]) {
      vue_runtime_esm["a" /* default */].set(state, payload, {});
    }
  }
};

// Actions
var forms_actions = {
  init: function init(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    var id = payload.id;
    var fields = payload.fields;

    if (state[id] && JSON.stringify(state[id]) !== JSON.stringify({})) {
      console.warn('Form already initialized');
      return false;
    }

    var form = {
      id: id,
      obj: {
        model: {},
        validations: {},
        valid: {},
        status: {
          loading: false,
          success: false
        },
        serverErrors: {
          _global: ''
        }
      }
    };

    Object(array["b" /* arrayLoop */])(fields, function (key, field) {
      var isConditional = field.conditional;
      if (field.value === '') {
        form.obj.model[key] = isConditional ? null : '';
      } else if (field.type === 'select') {
        form.obj.model[key] = field.value && !isConditional ? field.value : '_NULL';
      } else if (field.type === 'checkbox') {
        form.obj.model[key] = field.value && !isConditional ? field.value : [];
      } else {
        form.obj.model[key] = isConditional ? null : field.value;
      }
      form.obj.validations[key] = field.conditional ? {} : setValidation(key, field);
    });

    commit('createFormObject', form);
  },
  event: function event(_ref2) {
    var commit = _ref2.commit,
        dispatch = _ref2.dispatch,
        state = _ref2.state;
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (payload.event === 'input') {
      dispatch('updateValue', payload);
      var errors = state[payload.form].serverErrors;
      var fieldError = !!errors[payload.field];
      var globalError = !!errors._global;

      if ((fieldError || globalError) && payload.change === false) {
        dispatch('event', {
          form: payload.form,
          field: payload.field,
          event: 'serverError',
          error: ''
        });
      }
    } else if (payload.event === 'serverError') {

      commit('updateServerError', {
        form: payload.form,
        field: payload.field || false,
        error: payload.error
      });
    } else {
      console.warn('No form event type matched.');
    }
  },
  updateValue: function updateValue(_ref3, payload) {
    var commit = _ref3.commit;

    commit('updateValue', {
      form: payload.form,
      field: payload.field,
      value: payload.value
    });
  },
  setLoading: function setLoading(_ref4, payload) {
    var commit = _ref4.commit;

    commit('updateStatus', {
      form: payload,
      status: 'loading',
      value: true
    });
  },
  unsetLoading: function unsetLoading(_ref5, payload) {
    var commit = _ref5.commit;

    commit('updateStatus', {
      form: payload,
      status: 'loading',
      value: false
    });
  },
  setSuccess: function setSuccess(_ref6, payload) {
    var commit = _ref6.commit;

    commit('updateStatus', {
      form: payload,
      status: 'success',
      value: true
    });
  }
};

// Export
/* harmony default export */ var store_forms = ({
  namespaced: true,
  state: forms_state,
  getters: forms_getters,
  mutations: forms_mutations,
  actions: forms_actions
});
// CONCATENATED MODULE: ./client/store/meta.js


// Vue



// State
var meta_state = {
  meta: [],
  title: ''
};

// Getters
var meta_getters = {
  metaTitle: function metaTitle(state) {
    return state.title;
  }
};

// Mutations
var meta_mutations = {
  SET_META: function SET_META(state, meta) {
    vue_runtime_esm["a" /* default */].set(state, 'meta', meta);
  },
  SET_TITLE: function SET_TITLE(state, title) {
    state.title = title;
  }
};

// Actions
var meta_actions = {
  updateMeta: function updateMeta(_ref, meta) {
    var commit = _ref.commit;

    commit('SET_META', meta);
  },
  updateMetaTitle: function updateMetaTitle(_ref2, title) {
    var commit = _ref2.commit;

    commit('SET_TITLE', title);
  }
};

/* harmony default export */ var store_meta = ({
  namespaced: true,
  state: meta_state,
  getters: meta_getters,
  mutations: meta_mutations,
  actions: meta_actions
});
// EXTERNAL MODULE: ./client/router/index.js
var router = __webpack_require__(11);

// CONCATENATED MODULE: ./client/store/modals.js


// Vue




// Services


// State
var modals_state = {
  modals: {}
};

// Getters
var modals_getters = {
  modalActive: function modalActive(state) {
    var active = '';

    Object(array["b" /* arrayLoop */])(state.modals, function (id, modal) {
      if (modal.active) {
        active = id;
      }
    });

    return active;
  }
};

// Mutations
var modals_mutations = {
  CREATE_MODAL: function CREATE_MODAL(state, _ref) {
    var id = _ref.id,
        path = _ref.path;

    var modal = {
      active: false
    };

    if (path) {
      modal.path = path;
    }
    vue_runtime_esm["a" /* default */].set(state.modals, id, modal);
  },
  OPEN_MODAL: function OPEN_MODAL(state, _ref2) {
    var id = _ref2.id;

    if (!state.modals[id]) return;

    vue_runtime_esm["a" /* default */].set(state.modals[id], 'active', true);
  },
  CLOSE_MODAL: function CLOSE_MODAL(state, _ref3) {
    var id = _ref3.id;

    if (!state.modals[id]) return;

    vue_runtime_esm["a" /* default */].set(state.modals[id], 'active', false);
  }
};

// Actions
var modals_actions = {
  createModal: function createModal(_ref4, modal) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var id = modal.id;

    if (!id) return;

    if (!state.modals[id]) {
      commit('CREATE_MODAL', modal);
    }
  },
  pushState: function pushState(context) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var modal = modals_state.modals[id] || {};
    var path = modal.path || false;

    if (path) {
      path = encodeURI(path.charAt(0) === '/' ? path.substr(1) : path);
    }

    var currentRoute = Object.assign({}, router["a" /* default */].currentRoute);

    if (id) {
      currentRoute.query['modal' + (path ? '-path' : '')] = path || id;
    } else {
      currentRoute.query.modal = undefined;
      currentRoute.query['modal-path'] = undefined;
    }

    var route = router["a" /* default */].resolve(currentRoute);

    history.replaceState({}, '', route.href);
  },
  openModal: function openModal(_ref5, id) {
    var commit = _ref5.commit,
        dispatch = _ref5.dispatch,
        getters = _ref5.getters,
        state = _ref5.state,
        rootGetters = _ref5.rootGetters;


    if (!id) return;

    var modal = state.modals[id] || {};

    if (modal.path === router["a" /* default */].currentRoute.path) return;

    // WHY: Force the path change on small screens or touch devices
    if (modal.path && (rootGetters['app/viewportMobile'] || rootGetters['app/touch'])) {
      router["a" /* default */].push({
        path: modal.path
      });

      return;
    }

    var active = getters.modalActive;
    var timeout = 0;

    if (active) {
      if (id === active) return;

      timeout = 300; // TODO: Var
      dispatch('closeModal', active);
    }

    setTimeout(function () {
      commit('OPEN_MODAL', {
        id: id
      });

      dispatch('pushState', id);
    }, timeout);
  },
  closeModal: function closeModal(_ref6) {
    var commit = _ref6.commit,
        dispatch = _ref6.dispatch,
        getters = _ref6.getters;

    if (!getters.modalActive) return false;

    var id = getters.modalActive;

    commit('CLOSE_MODAL', {
      id: id
    });

    dispatch('pushState');
  }
};

/* harmony default export */ var modals = ({
  namespaced: true,
  state: modals_state,
  getters: modals_getters,
  mutations: modals_mutations,
  actions: modals_actions
});
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(50);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./client/api/http.js



var HTTP = axios_default.a.create({
  baseURL: config["a" /* default */].api,
  headers: {
    'Content-Type': 'application/json'
  }
});
// CONCATENATED MODULE: ./client/api/auth.js


var auth_requestRegisterUser = function requestRegisterUser(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/auth/register', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestLogin = function requestLogin(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/auth/login', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestResetPassword = function requestResetPassword(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/auth/password_reset', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestConfirmPassword = function requestConfirmPassword(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/auth/password_reset_confirm', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestCurrentUser = function requestCurrentUser() {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/me').then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestUpdatePassword = function requestUpdatePassword(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/auth/password_change', model).then(function (response) {
      return (response.status === 204 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestUpdateUser = function requestUpdateUser(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.patch('/me', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_getDentistLocations = function getDentistLocations() {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/clinics').then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestUpdateDentistLocation = function requestUpdateDentistLocation(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.patch('/clinics/' + model.id, model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestAddDentistLocation = function requestAddDentistLocation(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/clinics', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var auth_requestRemoveDentistLocation = function requestRemoveDentistLocation(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.delete('/clinics/' + id).then(function (response) {
      return (response.status === 204 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};
// CONCATENATED MODULE: ./client/models/global/roles.js


/* harmony default export */ var roles = ({
  1: {
    name: 'Patient',
    defaultRoute: 'dashboard-requests'
  },
  2: {
    name: 'Doctor',
    defaultRoute: 'dashboard-requests'
  },
  3: {
    name: 'Reviewer',
    defaultRoute: 'dashboard-reviews'
  },
  42: {
    name: 'Admin',
    defaultRoute: 'admin-reviewer-requests'
  }
});
// CONCATENATED MODULE: ./client/store/auth.js


// Vue




// API



// Services


// Models


// State
var auth_state = {
  authToken: "",
  user: {
    profile: {}
  },
  redirect: "",
  locations: {},
  locationsLoading: true,
  tourType: ""
};

// Getters
var auth_getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.authToken;
  },
  user: function user(state) {
    var user = state.user;

    var firstName = user.first_name || "";
    var lastName = user.last_name || "";
    var fullName = "" + firstName + (firstName ? " " : "") + lastName;

    if (!user.profile) user.profile = {};

    return Object.assign({}, user, {
      full_name: fullName,
      locations: state.locations,
      locationsCount: state.locationsLoading ? -1 : Object.keys(state.locations).length
    });
  },
  userRole: function userRole(state) {
    var role = state.user.role;
    var object = roles[role] || {};

    return {
      role: role,
      string: object.name,
      object: object
    };
  },
  userIsRole: function userIsRole(state) {
    return function (toCheck) {
      return toCheck === true || Object(array["a" /* arrayIncludes */])(toCheck, state.user.role);
    };
  },
  showTour: function showTour(state) {
    return state.tourType;
  }
};

// Mutations
var auth_mutations = {
  SET_TOUR: function SET_TOUR(state, value) {
    state.tourType = value;
  },
  SET_TOKEN: function SET_TOKEN(state, payload) {
    state.authToken = payload;
    localStorage.setItem("auth_token", payload);

    if (payload) {
      HTTP.defaults.headers.common.Authorization = "Token " + payload;
    } else {
      delete HTTP.defaults.headers.common.Authorization;
    }
  },
  SET_USER: function SET_USER(state, user) {
    vue_runtime_esm["a" /* default */].set(state, "user", user);
  },
  SET_REDIRECT: function SET_REDIRECT(state, payload) {
    vue_runtime_esm["a" /* default */].set(state, "redirect", payload || "");
  },
  SET_LOCATIONS: function SET_LOCATIONS(state, locations) {
    vue_runtime_esm["a" /* default */].set(state, "locations", locations);
  },
  SET_LOCATIONS_LOADING: function SET_LOCATIONS_LOADING(state, boolean) {
    state.locationsLoading = boolean;
  },
  SET_LOCATION_BY_ID: function SET_LOCATION_BY_ID(state, _ref) {
    var id = _ref.id,
        location = _ref.location;

    vue_runtime_esm["a" /* default */].set(state.locations, id, location);
  },
  REMOVE_LOCATION_BY_ID: function REMOVE_LOCATION_BY_ID(state, id) {
    // Vue.set(state.locations, id, undefined);
    var locations = {};

    Object(array["b" /* arrayLoop */])(state.locations, function (locationId, location) {
      if (id === locationId) return;

      locations[locationId] = location;
    });

    vue_runtime_esm["a" /* default */].set(state, "locations", locations);
  },
  SET_USER_PROFILE_VALUE: function SET_USER_PROFILE_VALUE(state, _ref2) {
    var key = _ref2.key,
        value = _ref2.value;

    vue_runtime_esm["a" /* default */].set(state.user.profile, key, value);
  },
  RESET_ON_LOGOUT: function RESET_ON_LOGOUT(state) {
    vue_runtime_esm["a" /* default */].set(state, "user", {
      profile: {}
    });
    vue_runtime_esm["a" /* default */].set(state, "locations", {});
    state.locationsLoading = false;
    state.redirect = "";
  }
};

// Actions
var auth_actions = {
  activateTour: function activateTour(_ref3, tourType) {
    var commit = _ref3.commit;

    commit("SET_TOUR", tourType || "");
  },
  deactivateTour: function deactivateTour(_ref4) {
    var commit = _ref4.commit;

    commit("SET_TOUR", "");
  },
  requestLogout: function requestLogout(_ref5) {
    var dispatch = _ref5.dispatch;
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new Promise(function (resolve) {
      var modulesToReset = ["auth", "review"];
      Object(array["b" /* arrayLoop */])(modulesToReset, function (i, module) {
        dispatch(module + "/resetOnLogout", null, {
          root: true
        });
      });
      setTimeout(function () {
        if (!args.noRedirect) {
          router["a" /* default */].push({
            name: "home"
          });
        }

        resolve();
      }, args.noDelay ? 500 : 0);
    });
  },
  requestLogin: function requestLogin(_ref6, model) {
    var dispatch = _ref6.dispatch,
        state = _ref6.state;

    return new Promise(function (resolve, reject) {
      auth_requestLogin(model).then(function (response) {
        dispatch("updateUser", response.data || {});
        resolve(response);
        var path = state.redirect;

        setTimeout(function () {
          router["a" /* default */].push(path ? { path: path } : { name: "dashboard" });
          dispatch("storeRedirect", "");
        }, 500);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestResetPassword: function requestResetPassword(context, model) {
    return new Promise(function (resolve, reject) {
      auth_requestResetPassword(model).then(function (response) {
        return resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestConfirmPassword: function requestConfirmPassword(_ref7, model) {
    var rootState = _ref7.rootState,
        state = _ref7.state,
        dispatch = _ref7.dispatch;

    return new Promise(function (resolve, reject) {
      var token = rootState.app.page.params.token;

      if (!token) {
        reject({
          errors: "No token"
        });
      } else {
        model.token = token;
      }

      auth_requestConfirmPassword(model).then(function (response) {
        var data = response.data || {};

        dispatch("updateUser", data);

        var path = state.redirect;

        vue_runtime_esm["a" /* default */].nextTick(function () {
          if (state.redirect) {
            router["a" /* default */].push(data.auth_token ? path : {
              name: "login"
            });
          }

          resolve(response);
        });
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestUpdatePassword: function requestUpdatePassword(context, _ref8) {
    var current_password = _ref8.current_password,
        new_password = _ref8.new_password;

    var model = {
      current_password: current_password,
      new_password: new_password
    };
    return auth_requestUpdatePassword(model);
  },
  requestUpdateUser: function requestUpdateUser(_ref9, model) {
    var dispatch = _ref9.dispatch;

    return new Promise(function (resolve, reject) {
      auth_requestUpdateUser(model).then(function (response) {
        dispatch("updateUser", response.data || {});
        resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestCurrentUser: function requestCurrentUser(_ref10, _ref11) {
    var state = _ref10.state,
        commit = _ref10.commit,
        dispatch = _ref10.dispatch;
    var auth_token = _ref11.auth_token,
        redirect = _ref11.redirect;

    if (!state.auth_token) {
      commit("SET_TOKEN", auth_token);
    }

    return new Promise(function (resolve, reject) {
      auth_requestCurrentUser().then(function (response) {
        var data = response.data || {};
        dispatch("updateUser", response.data || {});
        resolve(response);

        if (data.role === 2 || data.role === 3) dispatch("getDentistLocations");

        if (redirect) {
          var path = state.redirect;
          router["a" /* default */].push(path ? { path: path } : { name: "Home" });
        }
      }).catch(function (error) {
        console.error(error);
        dispatch("requestLogout", {
          noDelay: true
        });
        reject(error);
      });
    });
  },
  requestRegisterPatient: function requestRegisterPatient(_ref12, model) {
    var dispatch = _ref12.dispatch;

    model.role = 1;

    return new Promise(function (resolve, reject) {
      auth_requestRegisterUser(model).then(function (response) {
        dispatch("updateUser", response.data || {});

        var path = auth_state.redirect;
        router["a" /* default */].push(path ? { path: path } : { name: "dashboard" });

        resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestRegisterDentist: function requestRegisterDentist(_ref13, model) {
    var dispatch = _ref13.dispatch;

    model.role = 2;

    return new Promise(function (resolve, reject) {
      auth_requestRegisterUser(model).then(function (response) {
        dispatch("updateUser", response.data || {});
        var path = auth_state.redirect;
        router["a" /* default */].push(path ? { path: path } : { name: "dashboard" });

        resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  getDentistLocations: function getDentistLocations(_ref14) {
    var commit = _ref14.commit,
        dispatch = _ref14.dispatch;

    return new Promise(function (resolve, reject) {
      auth_getDentistLocations().then(function (res) {
        var locations = {};
        var data = res.data || {};
        var results = data.results || [];

        Object(array["b" /* arrayLoop */])(results, function (i, location) {
          return locations[location.id] = location;
        });

        commit("SET_LOCATIONS", locations);
        dispatch("setLocationsLoading", false);
        resolve(res.data);
      }).catch(function (err) {
        console.warn("getDentistLocations Err", err);
        reject(err);
      });
    });
  },
  requestUpdateDentistLocation: function requestUpdateDentistLocation(_ref15, model) {
    var dispatch = _ref15.dispatch;

    return new Promise(function (resolve, reject) {
      var action = model.id ? auth_requestUpdateDentistLocation : auth_requestAddDentistLocation;
      action(model).then(function (response) {
        dispatch("updateDentistLocation", response.data || {});
        resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },
  requestRemoveDentistLocation: function requestRemoveDentistLocation(_ref16, id) {
    var dispatch = _ref16.dispatch;

    return new Promise(function (resolve, reject) {
      auth_requestRemoveDentistLocation(id).then(function (response) {
        dispatch("removeDentistLocation", id);
        resolve(response);
      }).catch(function (error) {
        console.error(error);
        reject(error);
      });
    });
  },


  // requestRemoveDentistLocation(context, model) {
  //   return requestRemoveDentistLocation(model);
  // },

  removeDentistLocation: function removeDentistLocation(_ref17, id) {
    var commit = _ref17.commit;

    commit("REMOVE_LOCATION_BY_ID", id);
  },
  updateDentistLocation: function updateDentistLocation(_ref18, data) {
    var commit = _ref18.commit,
        dispatch = _ref18.dispatch;

    commit("SET_LOCATION_BY_ID", {
      id: data.id,
      location: data
    });
    dispatch("setLocationsLoading", false);
  },
  setLocationsLoading: function setLocationsLoading(_ref19, loading) {
    var commit = _ref19.commit;

    commit("SET_LOCATIONS_LOADING", loading);
  },
  updateUser: function updateUser(_ref20, data) {
    var commit = _ref20.commit;

    if (data.auth_token) {
      commit("SET_TOKEN", data.auth_token);
    }
    commit("SET_USER", data);
  },
  storeRedirect: function storeRedirect(_ref21, path) {
    var commit = _ref21.commit;

    commit("SET_REDIRECT", path);
  },
  updateUserProfileValue: function updateUserProfileValue(_ref22, _ref23) {
    var commit = _ref22.commit;
    var key = _ref23.key,
        value = _ref23.value;

    commit("SET_USER_PROFILE_VALUE", { key: key, value: value });
  },
  resetOnLogout: function resetOnLogout(_ref24) {
    var commit = _ref24.commit;

    commit("SET_TOKEN", "");
    commit("RESET_ON_LOGOUT");
  }
};

// Export
/* harmony default export */ var auth = ({
  namespaced: true,
  state: auth_state,
  getters: auth_getters,
  mutations: auth_mutations,
  actions: auth_actions
});
// CONCATENATED MODULE: ./client/api/review.js


var review_getNomenclature = function getNomenclature() {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/nomenclature').then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getReviewRequests = function getReviewRequests() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise(function (resolve, reject) {
    return HTTP.get(url || '/procedure_review_requests').then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getReviewRequestById = function getReviewRequestById(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/procedure_review_requests/' + id).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getNextReview = function getNextReview() {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/procedure_reviews').then(function (response) {
      return (response.status === 200 || 204 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_submitReview = function submitReview(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/procedure_reviews/' + model.id + '/review', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_requestReviewId = function requestReviewId(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/procedure_review_requests', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getReviewRequestsDoctor = function getReviewRequestsDoctor(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/upload_requests', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getReviewRequestsDoctorById = function getReviewRequestsDoctorById(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/upload_requests/' + id).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_getOrder = function getOrder(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.get('/order/' + id).then(function (response) {
      return (response.status === 200 || 204 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_requestReviewPostInfo = function requestReviewPostInfo(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/upload_requests/' + model.id + '/answer', model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_submitPayment = function submitPayment(model) {
  return new Promise(function (resolve, reject) {
    HTTP.post('/payment', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_submitCouponCode = function submitCouponCode(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post('/order/' + model.order_id + '/apply_coupon', model).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var review_requestReviewUploadImage = function requestReviewUploadImage(model) {
  var formData = new FormData();

  formData.append('image', model.image[0]);
  formData.append('date', model.date);
  formData.append('category', model.category);

  return new Promise(function (resolve, reject) {
    return HTTP.post('/upload_requests/' + model.id + '/files', formData).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};
// CONCATENATED MODULE: ./client/store/review.js


// Vue



// Services


// API


// State
var review_state = {
  nomenclature: {},
  requests: {
    next: '',
    count: 0,
    results: {}
  }
};

// Getters
var review_getters = {
  reviewNomenclature: function reviewNomenclature(state) {
    return state.nomenclature;
  },
  reviewRequests: function reviewRequests(state) {
    return state.requests;
  },
  reviewRequestsById: function reviewRequestsById(state) {
    return function (id) {
      return state.requests.results[id] || {};
    };
  },
  reviewRequestsLength: function reviewRequestsLength(state, getters) {
    return Object.keys(getters.reviewRequests.results).length;
  },
  reviewRequestsTotal: function reviewRequestsTotal(state) {
    return state.requests.count;
  },
  reviewNomenclatureBySlug: function reviewNomenclatureBySlug(state) {
    return function (slug) {
      var items = [];

      Object(array["b" /* arrayLoop */])(state.nomenclature[slug] || [], function (i, item) {
        items.push({
          option: item.name,
          value: item.id
        });
      });

      return items;
    };
  },
  reviewNomenclatureBySlugAndId: function reviewNomenclatureBySlugAndId(state, getters) {
    return function (slug, id) {
      var nomenclature = getters.reviewNomenclatureBySlug(slug) || [];
      var nomenclatureFilter = nomenclature.filter(function (item) {
        return item.value === id;
      }) || [];
      return nomenclatureFilter.length ? nomenclatureFilter[0].option : '';
    };
  }
};

// Mutations
var review_mutations = {
  SET_NOMENCLATURE: function SET_NOMENCLATURE(state, nomenclature) {
    vue_runtime_esm["a" /* default */].set(state, 'nomenclature', nomenclature);
  },
  CLEAR_REVIEWS: function CLEAR_REVIEWS(state) {
    vue_runtime_esm["a" /* default */].set(state.requests, 'results', {});

    state.requests.next = '';
    state.requests.count = 0;
  },
  UPDATE_REVIEWS: function UPDATE_REVIEWS(state, _ref) {
    var results = _ref.results,
        next = _ref.next,
        count = _ref.count;

    Object(array["b" /* arrayLoop */])(results, function (i, result) {
      return vue_runtime_esm["a" /* default */].set(state.requests.results, result.id, result);
    });

    state.requests.next = next;
    state.requests.count = count;
  },
  UPDATE_REVIEW_BY_ID: function UPDATE_REVIEW_BY_ID(state, review) {
    vue_runtime_esm["a" /* default */].set(state.requests.results, review.id, review);
  },
  RESET_ON_LOGOUT: function RESET_ON_LOGOUT(state) {
    vue_runtime_esm["a" /* default */].set(state, 'requests', {
      next: '',
      count: 0,
      results: {}
    });
  }
};

// Actions
var review_actions = {
  getNomenclature: function getNomenclature(_ref2) {
    var commit = _ref2.commit;

    return new Promise(function (resolve, reject) {
      review_getNomenclature().then(function (res) {
        commit('SET_NOMENCLATURE', res.data);
        resolve(res.data);
      }).catch(function (err) {
        console.warn('Nomenclature Err', err);
        reject(err);
      });
    });
  },
  getReviewRequests: function getReviewRequests(_ref3) {
    var commit = _ref3.commit;
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!url) {
      commit('CLEAR_REVIEWS');
    }

    return new Promise(function (resolve, reject) {
      review_getReviewRequests(url).then(function (res) {
        var data = res.data || {};
        var results = data.results || [];

        if (results.length) {
          commit('UPDATE_REVIEWS', data);
        }
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getReviewRequestsDoctor: function getReviewRequestsDoctor(_ref4) {
    var commit = _ref4.commit;
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!url) {
      commit('CLEAR_REVIEWS');
    }

    return new Promise(function (resolve, reject) {
      review_getReviewRequestsDoctor(url).then(function (res) {
        var data = res.data || {};
        var results = data.results || [];

        if (results.length) {
          commit('UPDATE_REVIEWS', data);
        }
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getReviewRequestsDoctorById: function getReviewRequestsDoctorById(_ref5, id) {
    var commit = _ref5.commit;

    return new Promise(function (resolve, reject) {
      review_getReviewRequestsDoctorById(id).then(function (res) {
        var data = res.data || {};
        commit('UPDATE_REVIEW_BY_ID', data);
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getReviewRequestById: function getReviewRequestById(context, id) {
    return review_getReviewRequestById(id);
  },

  getNextReview: review_getNextReview,
  requestReviewId: function requestReviewId(context, model) {
    return review_requestReviewId(model);
  },
  requestReviewPostInfo: function requestReviewPostInfo(context, model) {
    return review_requestReviewPostInfo(model);
  },
  requestReviewUploadImage: function requestReviewUploadImage(context, model) {
    return review_requestReviewUploadImage(model);
  },
  submitReview: function submitReview(context, model) {
    return review_submitReview(model);
  },
  resetOnLogout: function resetOnLogout(_ref6) {
    var commit = _ref6.commit;

    commit('RESET_ON_LOGOUT');
  }
};

/* harmony default export */ var store_review = ({
  namespaced: true,
  state: review_state,
  getters: review_getters,
  mutations: review_mutations,
  actions: review_actions
});
// CONCATENATED MODULE: ./client/store/payment.js


// API



// Actions
var payment_actions = {
  submitPayment: function submitPayment(context, model) {
    return review_submitPayment(model);
  },
  submitCouponCode: function submitCouponCode(context, model) {
    return review_submitCouponCode(model);
  },
  getOrder: function getOrder(context, model) {
    return review_getOrder(model);
  }
};

/* harmony default export */ var payment = ({
  namespaced: true,
  actions: payment_actions
});
// CONCATENATED MODULE: ./client/store/header.js


// State

var header_state = {
  transitionState: 'hidden',
  isTransitioning: false
};

// Getters
var header_getters = {
  headerTransitionState: function headerTransitionState(state) {
    return state.transitionState;
  }
};

// Mutations
var header_mutations = {
  CHANGE_STATE: function CHANGE_STATE(state, transitionState) {
    state.transitionState = transitionState;
  },
  SET_TRANSITIONING: function SET_TRANSITIONING(state, boolean) {
    state.isTransitioning = boolean;
  }
};

// Actions
var header_actions = {
  toggleHeader: function toggleHeader(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.isTransitioning) return false;
    commit('SET_TRANSITIONING', true);
    var stepOne = 'out';
    var stepTwo = 'hidden';

    if (state.transitionState === 'hidden') {
      stepOne = 'in';
      stepTwo = 'show';
    }
    commit('CHANGE_STATE', stepOne);

    setTimeout(function () {
      commit('CHANGE_STATE', stepTwo);
      commit('SET_TRANSITIONING', false);
    }, 200);
  }
};

/* harmony default export */ var header = ({
  namespaced: true,
  state: header_state,
  getters: header_getters,
  mutations: header_mutations,
  actions: header_actions
});
// CONCATENATED MODULE: ./client/store/dashboard.js


// State

var dashboard_state = {
  transitionState: 'hidden',
  isTransitioning: false
};

// Getters
var dashboard_getters = {
  dashboardTransitionState: function dashboardTransitionState(state) {
    return state.transitionState;
  }
};

// Mutations
var dashboard_mutations = {
  CHANGE_STATE: function CHANGE_STATE(state, transitionState) {
    state.transitionState = transitionState;
  },
  SET_TRANSITIONING: function SET_TRANSITIONING(state, boolean) {
    state.isTransitioning = boolean;
  }
};

// Actions
var dashboard_actions = {
  toggleDashboard: function toggleDashboard(_ref, show) {
    var commit = _ref.commit,
        state = _ref.state;

    if (state.isTransitioning) return false;

    commit('SET_TRANSITIONING', true);

    var stepOne = 'out';
    var stepTwo = 'hidden';

    if (state.transitionState === 'hidden' && show !== false) {
      stepOne = 'in';
      stepTwo = 'show';
    }

    commit('CHANGE_STATE', stepOne);

    setTimeout(function () {
      commit('CHANGE_STATE', stepTwo);
      commit('SET_TRANSITIONING', false);
    }, 400);
  }
};

/* harmony default export */ var dashboard = ({
  namespaced: true,
  state: dashboard_state,
  getters: dashboard_getters,
  mutations: dashboard_mutations,
  actions: dashboard_actions
});
// CONCATENATED MODULE: ./client/api/reviewer.js
// API


var reviewer_requestBecomeReviewer = function requestBecomeReviewer(model) {

  var formData = new FormData();

  formData.append("identity_card", model.identity_card[0]);
  formData.append("dental_license", model.dental_license[0]);
  formData.append("specialty_certificate", model.specialty_certificate[0]);

  return new Promise(function (resolve, reject) {
    return HTTP.post("/reviewer_status_requests", formData).then(function (response) {
      return (response.status === 201 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var reviewer_getReviewerRequests = function getReviewerRequests() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise(function (resolve, reject) {
    return HTTP.get(url || "/reviewer_status_requests").then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var reviewer_getReviewerRequestById = function getReviewerRequestById(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.get("/reviewer_status_requests/" + id).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var reviewer_submitReviewerRequestDecision = function submitReviewerRequestDecision(model) {
  return new Promise(function (resolve, reject) {
    return HTTP.post("/reviewer_status_requests/" + model.id + "/review", model).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};
// CONCATENATED MODULE: ./client/store/reviewer.js


// Vue



// Services




// State
var reviewer_state = {
  requests: {
    next: '',
    count: 0,
    results: {}
  }
};

// Getters
var reviewer_getters = {
  reviewerRequests: function reviewerRequests(state) {
    return state.requests;
  },
  reviewerRequestById: function reviewerRequestById(state) {
    return function (id) {
      return state.requests.results[id] || {};
    };
  },
  reviewerRequestsLength: function reviewerRequestsLength(state, getters) {
    return Object.keys(getters.reviewerRequests.results).length;
  },
  reviewerRequestsTotal: function reviewerRequestsTotal(state) {
    return state.requests.count;
  }
};

// Mutations
var reviewer_mutations = {
  CLEAR_REQUESTS: function CLEAR_REQUESTS(state) {
    vue_runtime_esm["a" /* default */].set(state.requests, 'results', {});

    state.requests.next = '';
    state.requests.count = 0;
  },
  UPDATE_REQUESTS: function UPDATE_REQUESTS(state, _ref) {
    var results = _ref.results,
        next = _ref.next,
        count = _ref.count;

    Object(array["b" /* arrayLoop */])(results, function (i, result) {
      return vue_runtime_esm["a" /* default */].set(state.requests.results, result.id, result);
    });

    state.requests.next = next;
    state.requests.count = count;
  },
  RESET_ON_LOGOUT: function RESET_ON_LOGOUT(state) {
    vue_runtime_esm["a" /* default */].set(state, 'requests', {
      next: '',
      count: 0,
      results: {}
    });
  }
};

// Actions
var reviewer_actions = {
  requestBecomeReviewer: function requestBecomeReviewer(_ref2, model) {
    var dispatch = _ref2.dispatch;

    return new Promise(function (resolve, reject) {
      reviewer_requestBecomeReviewer(model).then(function (res) {
        dispatch('auth/updateUserProfileValue', { key: 'has_applied_for_reviewer_privileges', value: true }, { root: true });
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getReviewerRequests: function getReviewerRequests(_ref3) {
    var commit = _ref3.commit;
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!url) {
      commit('CLEAR_REQUESTS');
    }

    return new Promise(function (resolve, reject) {
      reviewer_getReviewerRequests(url).then(function (res) {
        var data = res.data || {};
        var results = data.results || [];

        if (results.length) {
          commit('UPDATE_REQUESTS', data);
        }
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getReviewerRequestById: function getReviewerRequestById(context, id) {
    return reviewer_getReviewerRequestById(id);
  },
  submitReviewerRequestDecision: function submitReviewerRequestDecision(context, model) {
    return reviewer_submitReviewerRequestDecision(model);
  },
  resetOnLogout: function resetOnLogout(_ref4) {
    var commit = _ref4.commit;

    commit('RESET_ON_LOGOUT');
  }
};

// Export
/* harmony default export */ var reviewer = ({
  namespaced: true,
  state: reviewer_state,
  getters: reviewer_getters,
  mutations: reviewer_mutations,
  actions: reviewer_actions
});
// CONCATENATED MODULE: ./client/api/emails.js


var emails_getEmailLogs = function getEmailLogs() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return new Promise(function (resolve, reject) {
    return HTTP.get(url || "/email-logs").then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var emails_getEmailLogById = function getEmailLogById(id) {
  return new Promise(function (resolve, reject) {
    return HTTP.get("/email-logs/" + id).then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};

var emails_getEmailActivity = function getEmailActivity(id) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise(function (resolve, reject) {
    return HTTP.get(url || "/email-logs/" + id + "/activity").then(function (response) {
      return (response.status === 200 ? resolve : reject)(response);
    }).catch(function (error) {
      return reject(error.response);
    });
  });
};
// CONCATENATED MODULE: ./client/store/emails.js


// Vue



// Services


// API


// State
var emails_state = {
  emails: {
    next: '',
    count: 0,
    results: {}
  },
  emailActivities: {
    next: '',
    count: 0,
    results: {}
  }
};

// Getters
var emails_getters = {
  emailLogs: function emailLogs(state) {
    return state.emails;
  },
  emailLogsById: function emailLogsById(state) {
    return function (id) {
      return state.emails.results[id] || {};
    };
  },
  emailLogsLength: function emailLogsLength(state, getters) {
    return Object.keys(getters.emailLogs.results).length;
  },
  emailLogsTotal: function emailLogsTotal(state) {
    return state.emails.count;
  },
  emailActivity: function emailActivity(state) {
    return state.emailActivities;
  },
  emailActivityById: function emailActivityById(state) {
    return function (id) {
      return state.emailActivities.results[id] || {};
    };
  },
  emailActivityLength: function emailActivityLength(state, getters) {
    return Object.keys(getters.emailActivity.results).length;
  },
  emailActivityTotal: function emailActivityTotal(state) {
    return state.emailActivities.count;
  }
};

// Mutations
var emails_mutations = {
  CLEAR_EMAIL_LOGS: function CLEAR_EMAIL_LOGS(state) {
    vue_runtime_esm["a" /* default */].set(state.emails, 'results', {});

    state.emails.next = '';
    state.emails.count = 0;
  },
  UPDATE_EMAIL_LOGS: function UPDATE_EMAIL_LOGS(state, _ref) {
    var results = _ref.results,
        next = _ref.next,
        count = _ref.count;

    Object(array["b" /* arrayLoop */])(results, function (i, result) {
      return vue_runtime_esm["a" /* default */].set(state.emails.results, result.id, result);
    });

    state.emails.next = next;
    state.emails.count = count;
  },
  RESET_EMAIL_LOGS_ON_LOGOUT: function RESET_EMAIL_LOGS_ON_LOGOUT(state) {
    vue_runtime_esm["a" /* default */].set(state, 'emails', {
      next: '',
      count: 0,
      results: {}
    });
  },
  CLEAR_EMAIL_ACTIVITY: function CLEAR_EMAIL_ACTIVITY(state) {
    vue_runtime_esm["a" /* default */].set(state.emailActivities, 'results', {});

    state.emailActivities.next = '';
    state.emailActivities.count = 0;
  },
  UPDATE_EMAIL_ACTIVITY: function UPDATE_EMAIL_ACTIVITY(state, _ref2) {
    var results = _ref2.results,
        next = _ref2.next,
        count = _ref2.count;

    Object(array["b" /* arrayLoop */])(results, function (i, result) {
      return vue_runtime_esm["a" /* default */].set(state.emailActivities.results, result.id, result);
    });

    state.emailActivities.next = next;
    state.emailActivities.count = count;
  },
  RESET_EMAIL_ACTIVITY_ON_LOGOUT: function RESET_EMAIL_ACTIVITY_ON_LOGOUT(state) {
    vue_runtime_esm["a" /* default */].set(state, 'emailActivities', {
      next: '',
      count: 0,
      results: {}
    });
  }
};

// Actions
var emails_actions = {
  getEmailLogs: function getEmailLogs(_ref3) {
    var commit = _ref3.commit;
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!url) {
      commit('CLEAR_EMAIL_LOGS');
    }

    return new Promise(function (resolve, reject) {
      emails_getEmailLogs(url).then(function (res) {
        var data = res.data || {};
        var results = data.results || [];

        if (results.length) {
          commit('UPDATE_EMAIL_LOGS', data);
        }
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  getEmailActivity: function getEmailActivity(_ref4, id) {
    var commit = _ref4.commit;
    var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (!url) {
      commit('CLEAR_EMAIL_ACTIVITY');
    }

    return new Promise(function (resolve, reject) {
      emails_getEmailActivity(id, url).then(function (res) {
        var data = res.data || {};
        var results = data.results || [];

        if (results.length) {
          commit('UPDATE_EMAIL_ACTIVITY', data);
        }
        resolve(res);
      }).catch(function (err) {
        reject(err);
      });
    });
  },
  resetOnLogout: function resetOnLogout(_ref5) {
    var commit = _ref5.commit;

    commit('RESET_EMAIL_LOGS_ON_LOGOUT');
    commit('RESET_EMAIL_ACTIVITY_ON_LOGOUT');
  }
};

/* harmony default export */ var emails = ({
  namespaced: true,
  state: emails_state,
  getters: emails_getters,
  mutations: emails_mutations,
  actions: emails_actions
});
// CONCATENATED MODULE: ./client/store/index.js















vue_runtime_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({ // eslint-disable-line import/no-named-as-default-member
  modules: {
    app: app,
    forms: store_forms,
    meta: store_meta,
    modals: modals,
    auth: auth,
    review: store_review,
    payment: payment,
    header: header,
    dashboard: dashboard,
    reviewer: reviewer,
    emails: emails
  }
});

/* harmony default export */ var client_store = __webpack_exports__["a"] = (store);

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/*!********************************************!*\
  !*** ./client/components/modules/Form.vue ***!
  \********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Form.vue */ 66),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7fa08fa0"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Form.vue */ 113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */
/*!*********************************!*\
  !*** ./client/services/meta.js ***!
  \*********************************/
/*! exports provided: createMeta */
/*! exports used: createMeta */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createMeta; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(/*! config */ 6);




function createMeta(meta) {
  /*
    ** TO ADD **
    - <html> language/locale
    - Canonical
    - Next
    - Prev
    - og:image:width
    - og:image:height
    */

  var array = [];
  var legend = [
  // Standard
  {
    name: 'description',
    value: 'description'
  }, {
    name: 'generator',
    value: 'generator'
  },

  // Facebook (og)
  {
    property: 'og:title',
    value: 'title'
  }, {
    property: 'og:description',
    value: 'description'
  }, {
    property: 'og:locale',
    value: 'locale'
  }, {
    property: 'og:url',
    value: 'url'
  }, {
    property: 'og:type',
    value: 'type'
  }, {
    property: 'og:site_name',
    value: 'company'
  }, {
    property: 'og:image',
    value: 'image'
  }, {
    property: 'og:image:secure_url',
    value: 'image'
  },

  // Twitter
  {
    name: 'twitter:title',
    value: 'title'
  }, {
    name: 'twitter:description',
    value: 'description'
  }, {
    name: 'twitter:site',
    value: 'twitterHandle'
  }, {
    name: 'twitter:card',
    value: 'twitterCard'
  }, {
    name: 'twitter:image',
    value: 'image'
  }, {
    name: 'twitter:label1',
    value: 'labelOne'
  }, {
    name: 'twitter:data1',
    value: 'dataOne'
  }, {
    name: 'twitter:label2',
    value: 'labelTwo'
  }, {
    name: 'twitter:data2',
    value: 'dataTwo'
  }];

  for (var i = 0; i < legend.length; i++) {
    var key = legend[i];
    var metaItem = {};
    var name = key.name || key.property;
    var content = meta[key.value];

    if (content) {
      metaItem.vmid = name;
      metaItem[key.name ? 'name' : 'property'] = name;
      metaItem.content = meta[key.value];

      array.push(metaItem);
    }
  }

  var isProd = __WEBPACK_IMPORTED_MODULE_0_config__["a" /* default */].env === 'prod';
  var noFollow = !isProd || meta.noFollow === true;
  var noIndex = !isProd || meta.noIndex === true;

  array.push({
    vmid: 'index',
    name: 'robots',
    content: (noIndex ? 'no' : '') + 'index, ' + (noFollow ? 'no' : '') + 'follow'
  });

  return array;
}



/***/ }),
/* 43 */
/*!***********************************************!*\
  !*** ./client/components/modules/Spinner.vue ***!
  \***********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Spinner.vue */ 83),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-2156f126"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Spinner.vue */ 84),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 44 */
/*!******************************************!*\
  !*** ./client/components/ui/Tooltip.vue ***!
  \******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tooltip.vue */ 111),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-019ec19c"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tooltip.vue */ 112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 45 */
/*!***********************************!*\
  !*** ./client/services/string.js ***!
  \***********************************/
/*! exports provided: toCapitalizedCase, toKebabCase, toPlural, stringifyObject, americanizePhoneNumber */
/*! exports used: americanizePhoneNumber, stringifyObject */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export toCapitalizedCase */
/* unused harmony export toKebabCase */
/* unused harmony export toPlural */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return stringifyObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return americanizePhoneNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_array__ = __webpack_require__(/*! services/array */ 2);


// Services

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



// @function toCapitalizedCase(string)
// Capitalize the first character of a string
//
// @param {string} string – The string to capitalize
// @returns {string} Capitalized string
var toCapitalizedCase = function toCapitalizedCase(string) {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
};

// @function toKebabCase(string)
// Turn a camelCase string into a kebab-case-string
//
// @param {string} string – The camelCase string to kebab-case
// @returns {string} camelCase string
var toKebabCase = function toKebabCase(string) {
  return string ? string.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase() : '';
};

// @function toPlural(count, string, plural)
// Pluralize strings by adding s or specifying a plural based on the count
//
// @param {number} count – The number by which to pluralized
// @param {string} string – The string
// @param {string} [plural] – A plural string
// @returns {string} Pluralized string
var toPlural = function toPlural() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var plural = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return !string || count === 1 ? string : plural || string + 's';
};

// @function stringifyObject(jsonObj, level)
// Convert any JSON/JS object into a string that conforms to our JS linting rules
//
// @param {array|object} jsonObj – The object to stringify
// @param {number=0} level – The depth of object (i.e. the number of tabs to add)
// @returns {string} – strigified object
var stringifyObject = function stringifyObject(jsonObj) {
  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // Use native stringify for anything that isn’t an object
  if (typeof jsonObj === 'string') {
    return '`' + jsonObj + '`';
  } else if (typeof jsonObj !== 'object') {
    return JSON.stringify(jsonObj);
  }

  var indent = '';
  Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(level, function (i) {
    // eslint-disable-line no-unused-vars
    indent += '\t';
  });

  if (Array.isArray(jsonObj)) {
    var arr = '';

    Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(jsonObj, function (index, item) {
      arr += '\n\t' + indent + stringifyObject(item, level + 1) + ',';
    });

    return arr ? '[' + arr + '\n' + indent + ']' : '[]';
  }

  var obj = '';
  Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(jsonObj, function (key, val) {
    var valType = typeof val === 'undefined' ? 'undefined' : _typeof(val);
    var value = null;

    if (valType === 'string') {
      value = '`' + val + '`';
    } else if (valType === 'number') {
      value = val;
    } else if (valType === 'boolean') {
      value = val ? 'true' : 'false';
    } else if (valType === 'object') {
      value = stringifyObject(val, level + 1);
    }

    if (value !== null) {
      obj += '\n\t' + indent + key + ': ' + value + ',';
    }
  });

  return obj ? '{ ' + obj + '\n' + indent + '}' : '{}';
};

// Americanize Number
// @param {tel} string – the telephone number
var americanizePhoneNumber = function americanizePhoneNumber() {
  var tel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !tel ? tel : tel.substr(0, 1) === '+' ? tel : '+1' + tel;
};

/***/ }),
/* 46 */
/*!*********************************************!*\
  !*** ./client/components/modules/Modal.vue ***!
  \*********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Modal.vue */ 59),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e6eff5fe"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Modal.vue */ 119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/*!*******************************************************!*\
  !*** ./client/assets/images/icons/spinner.svg?inline ***!
  \*******************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"#FFF","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M20 40a20 20 0 1 1 0-40 20 20 0 0 1 0 40zm0-5a15 15 0 1 0 0-30 15 15 0 0 0 0 30z","fill-opacity":".25"}}),_c('path',{attrs:{"d":"M10.98 2.15A19.92 19.92 0 0 1 20 0c3.25 0 6.31.77 9.02 2.15L26.95 6.7a14.93 14.93 0 0 0-13.9 0l-2.07-4.55z"}})])])}}};

/***/ }),
/* 48 */
/*!***********************************************!*\
  !*** ./client/components/ui/ExpandButton.vue ***!
  \***********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-7bc0e323","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExpandButton.vue */ 105)

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExpandButton.vue */ 106),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7bc0e323"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExpandButton.vue */ 107),
  /* scopeId */
  "data-v-7bc0e323",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 49 */
/*!*******************************************!*\
  !*** ./client/components/ui/Expander.vue ***!
  \*******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-0945bb7e","scoped":true,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Expander.vue */ 108)

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Expander.vue */ 109),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0945bb7e"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Expander.vue */ 110),
  /* scopeId */
  "data-v-0945bb7e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */
/*!*************************************!*\
  !*** ./client/index.js + 5 modules ***!
  \*************************************/
/*! no exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is an entry point */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/promise-polyfill/promise.js
var promise = __webpack_require__(52);
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./client/promise-polyfill.js


window.Promise = window.Promise || promise_default.a;
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.runtime.esm.js
var vue_runtime_esm = __webpack_require__(3);

// EXTERNAL MODULE: ./client/config.js
var config = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__(54);
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// EXTERNAL MODULE: ./client/components/App.vue
var App = __webpack_require__(55);
var App_default = /*#__PURE__*/__webpack_require__.n(App);

// EXTERNAL MODULE: ./client/router/index.js
var router = __webpack_require__(11);

// EXTERNAL MODULE: ./client/store/index.js + 18 modules
var store = __webpack_require__(34);

// EXTERNAL MODULE: ./node_modules/vue-resource/dist/vue-resource.esm.js
var vue_resource_esm = __webpack_require__(169);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__(171);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue-scrollto/vue-scrollto.js
var vue_scrollto = __webpack_require__(14);
var vue_scrollto_default = /*#__PURE__*/__webpack_require__.n(vue_scrollto);

// EXTERNAL MODULE: ./node_modules/vue-meta/lib/vue-meta.js
var vue_meta = __webpack_require__(173);
var vue_meta_default = /*#__PURE__*/__webpack_require__.n(vue_meta);

// CONCATENATED MODULE: ./client/plugins/meta.js



vue_runtime_esm["a" /* default */].use(vue_meta_default.a, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid'
});
// EXTERNAL MODULE: ./client/services/array.js
var array = __webpack_require__(2);

// EXTERNAL MODULE: ./client/services/scroll.js + 1 modules
var services_scroll = __webpack_require__(18);

// CONCATENATED MODULE: ./client/plugins/scroll.js
// Vue


// Services



// @function activateChild
// Makes a child active
//
// @param {Element} child - a JavaScript element to assign the active state to

var activateChild = function activateChild(child) {
  return child.classList.add('reveal__child--active');
};

// @function getChildren
// Gets children of the specified selector
//
// @param {Element} el – a JavaScript element to get the children from
// @param {Object} value – the value Object from the directive

var getChildren = function getChildren(el, _ref) {
  var child = _ref.child;
  return (child ? el.querySelectorAll(child) : el.children) || [];
};

// @function setupChildren
// Gets children, loops through them and adds the requisite child class
//
// @param {Element} el – a JavaScript element to get the children from
// @param {Object} value – the value Object from the directive

var scroll_setupChildren = function setupChildren(el, value) {
  var children = getChildren(el, value);
  var elActive = el.dataset.scrollReveal === 'true';

  Object(array["b" /* arrayLoop */])(children, function (i, child) {
    child.classList.add('reveal__child');

    if (value.stagger) {
      child.classList.add('reveal__child--stagger');
      child.style.setProperty('--reveal-delay', i);
    }

    if (elActive) {
      activateChild(child);
    }
  });
};

// @directive scroll-reveal
// Add scroll reveal
//
// @param {Object} value – The propertise object for the reveal
// @param {String} value.id – unique id for this scroll section
// @param {Number} [value.stagger=125] – time between each element being revealed (ms)
// @param {Selector} [value.child] – specific child to apply active class to, defaults to the direct children
// @param {Function} [value.enter] – callback triggered on element enter
// @param {Object} [value.enterProps] – properties object for enter
// @param {Number} [value.enterProps.trigger=66.67] – trigger percentage of viewport for enter to be set

vue_runtime_esm["a" /* default */].directive('scroll-reveal', {
  inserted: function inserted(el, _ref2) {
    var value = _ref2.value;

    if (!value) value = {};

    var id = value.id;

    if (!id) {
      console.warn('No id specified for v-scroll-reveal');
      return false;
    }

    el.classList.add('reveal');
    el.dataset.scrollReveal = false;

    scroll_setupChildren(el, value);

    if (value.stagger && value.stagger !== true) {
      el.classList.add('reveal--stagger');
      el.style.setProperty('--reveal-stagger', value.stagger);
    }

    Object(services_scroll["a" /* createScroll */])('reveal-' + id, {
      el: el,
      enter: function enter() {
        if (typeof value.enter === 'function') value.enter();

        el.classList.add('reveal--active');
        el.dataset.scrollReveal = true;

        Object(array["b" /* arrayLoop */])(getChildren(el, value), function (i, child) {
          return activateChild(child);
        });
      },
      enterProps: value.enterProps || {}
    });
  },
  componentUpdated: function componentUpdated(el, _ref3) {
    var value = _ref3.value;

    scroll_setupChildren(el, value);
  },
  unbind: function unbind(el, _ref4) {
    var value = _ref4.value;

    var id = (value || {}).id;

    if (id) Object(services_scroll["b" /* destroyScroll */])('reveal-' + id);
  }
});
// CONCATENATED MODULE: ./client/plugins/index.js
/* eslint-disable import/default */





// import VueClipboard from 'v-clipboard';

 // eslint-disable-line no-unused-vars
 // eslint-disable-line no-unused-vars
/* eslint-enable import/default */

vue_runtime_esm["a" /* default */].use(vue_resource_esm["a" /* default */]);
vue_runtime_esm["a" /* default */].use(lib_default.a);
vue_runtime_esm["a" /* default */].use(vue_scrollto_default.a);
// Vue.use(VueClipboard);
// CONCATENATED MODULE: ./client/app.js
/* eslint-disable import/default */




console.log('Evironment:', config["a" /* default */].env); // eslint-disable-line no-console






 // eslint-disable-line no-unused-vars

var unsync = Object(vuex_router_sync["sync"])(store["a" /* default */], router["a" /* default */]); // eslint-disable-line no-unused-vars

var app = new vue_runtime_esm["a" /* default */](Object.assign({
  router: router["a" /* default */],
  store: store["a" /* default */]
}, App_default.a));


/* eslint-enable import/default */
// CONCATENATED MODULE: ./client/index.js



document.addEventListener('DOMContentLoaded', function () {
  return app.$mount('#app');
});

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/*!***********************************!*\
  !*** ./client/components/App.vue ***!
  \***********************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-63713ffd","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 56)

var Component = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 58),
  /* template */
  __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-63713ffd"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 129),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-63713ffd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/App.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */,
/* 58 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/App.vue + 1 modules ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/App.vue (referenced with cjs require) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/config.js because of ./client/index.js */
/*! ModuleConcatenation bailout: Cannot concat with ./client/services/gtag.js because of ./client/index.js */
/*! ModuleConcatenation bailout: Cannot concat with ./client/services/meta.js because of ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/views/404.vue */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Modal.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/ui/Auth.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/ui/Header.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./client/config.js
var config = __webpack_require__(6);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// EXTERNAL MODULE: ./client/services/meta.js
var meta = __webpack_require__(42);

// EXTERNAL MODULE: ./client/services/gtag.js + 1 modules
var gtag = __webpack_require__(22);

// CONCATENATED MODULE: ./client/services/livechat.js


var livechat_injectLiveChat = function injectLiveChat() {
  if (config["a" /* default */].env !== 'prod') {
    return;
  }

  var body = document.getElementsByTagName('body');
  if (body.length) {
    var liveChatScript = document.createElement('script');
    var textNode = document.createTextNode('window.__lc = window.__lc || {};\n      window.__lc.license = 10865982;\n      (function() {\n        var lc = document.createElement(\'script\'); lc.type = \'text/javascript\'; lc.async = true;\n        lc.src = \'https://cdn.livechatinc.com/tracking.js\';\n        var s = document.getElementsByTagName(\'script\')[0]; s.parentNode.insertBefore(lc, s);\n      })();');
    liveChatScript.appendChild(textNode);
    body[0].appendChild(liveChatScript);
  }
};
// EXTERNAL MODULE: ./client/components/modules/Modal.vue
var Modal = __webpack_require__(46);
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);

// EXTERNAL MODULE: ./client/components/ui/Auth.vue
var Auth = __webpack_require__(16);
var Auth_default = /*#__PURE__*/__webpack_require__.n(Auth);

// EXTERNAL MODULE: ./client/components/ui/Header.vue
var Header = __webpack_require__(120);
var Header_default = /*#__PURE__*/__webpack_require__.n(Header);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Config


// Vuex


// Services




// Modules


// UI



// Export
/* harmony default export */ var App = __webpack_exports__["default"] = ({
  name: 'app',

  // Meta info
  metaInfo: function metaInfo() {
    return {
      titleTemplate: function titleTemplate(titleChunk) {
        return '' + (config["a" /* default */].env !== 'prod' ? '[' + config["a" /* default */].env + '] ' : '') + config["a" /* default */].name + (titleChunk ? '' + config["a" /* default */].meta.separator + titleChunk : '');
      },

      htmlAttrs: {
        prefix: 'og: http://ogp.me/ns#'
      },
      meta: Object(meta["a" /* createMeta */])({
        type: 'website',
        url: '' + config["a" /* default */].rootUrl + this.$route.fullPath,
        title: this.metaTitle,
        company: config["a" /* default */].name,
        image: config["a" /* default */].openGraph
      }),
      changed: function changed(metaInfo /*, added, removed*/) {
        if (metaInfo.title !== this.metaTitle && this.updateMetaTitle) {
          this.updateMetaTitle(metaInfo.title);
        }

        if (this.$route.name && metaInfo.titleChunk) {
          document.dispatchEvent(new Event('custom-post-render-event'));
        }

        if (this.updateMeta) {
          this.updateMeta(metaInfo);
        }
      }
    };
  },


  // Components
  components: {
    ModuleModal: Modal_default.a,
    UiAuth: Auth_default.a,
    UiHeader: Header_default.a
  },

  // Data
  computed: Object.assign({}, Object(vuex_esm["c" /* mapGetters */])('meta', ['metaTitle']), Object(vuex_esm["c" /* mapGetters */])('app', ['appEnv', 'appState', 'appPage']), Object(vuex_esm["c" /* mapGetters */])('modals', ['modalActive'])),
  watch: {
    modalActive: function modalActive(active) {
      var classList = document.body.classList;
      var className = 'body--modal-open';

      active ? classList.add(className) : classList.remove(className);
    }
  },

  // Methods
  methods: Object.assign({}, Object(vuex_esm["b" /* mapActions */])('app', ['openLoader', 'updatePage', 'closeLoader', 'updateViewport', 'setTouch']), Object(vuex_esm["b" /* mapActions */])('meta', ['updateMeta', 'updateMetaTitle']), Object(vuex_esm["b" /* mapActions */])('modals', ['closeModal']), Object(vuex_esm["b" /* mapActions */])('review', ['getNomenclature']), {
    onLeave: function onLeave() {
      this.openLoader();
      this.closeModal();
    },
    onLoad: function onLoad() {
      this.updatePage();

      if (this.appState.init) {
        this.closeLoader();
      }
    }
  }),

  // Lifecycle
  created: function created() {
    var _this = this;

    Object(gtag["a" /* injectGtag */])();
    this.updateViewport();
    this.setTouch();
    this.getNomenclature();

    window.addEventListener('resize', function () {
      return _this.updateViewport();
    }, true);
  },
  mounted: function mounted() {
    livechat_injectLiveChat();
  },
  destroyed: function destroyed() {
    var _this2 = this;

    window.removeEventListener('resize', function () {
      return _this2.updateViewport();
    }, true);
  }
});

/***/ }),
/* 59 */
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Modal.vue ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Modal.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_modal_Close__ = __webpack_require__(/*! modules/modal/Close */ 60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_modal_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_modal_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth__ = __webpack_require__(/*! ui/Auth */ 16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ui_Auth__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Modules


// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-modal',

  // Components
  components: {
    ModuleModalClose: __WEBPACK_IMPORTED_MODULE_1_modules_modal_Close___default.a,
    UiAuth: __WEBPACK_IMPORTED_MODULE_2_ui_Auth___default.a
  },

  // Props
  props: {
    id: {
      type: String,
      required: true
    },
    auth: String,
    noClose: Boolean,
    auto: Boolean
  },

  // Data
  data: function data() {
    return {
      visible: false
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('modals', ['modalActive']), {
    active: function active() {
      return this.modalActive === this.id;
    },
    hasHeader: function hasHeader() {
      return !!this.$slots.header;
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.footer;
    }
  }),
  watch: {
    active: function active(_active) {
      this.setActive(_active);
    }
  },

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('modals', ['createModal', 'closeModal']), {
    setActive: function setActive(active) {
      var _this = this;

      if (active && this.auth && this.isAuthenticated) {
        this.visible = false;
        this.closeModal();
      } else {
        setTimeout(function () {
          _this.visible = active;
        }, active ? 0 : 300); // TODO: Var
      }
    }
  }),

  // Lifecycle
  created: function created() {
    if (this.active) {
      this.setActive(true);
    }

    var modal = {
      id: this.id
    };

    if (this.auth) {
      var route = this.$router.resolve({
        name: this.auth
      });

      modal.path = ((route || {}).route || {}).fullPath;
    }

    this.createModal(modal);
  }
});

/***/ }),
/* 60 */
/*!***************************************************!*\
  !*** ./client/components/modules/modal/Close.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Close.vue */ 61),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-d6bbbe2c"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Close.vue */ 64),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/modal/Close.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/modal/Close.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Icon__);
//
//
//
//
//
//
//
//
//
//

// Vuex


// Modules


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-modal-close',

  // Components
  components: {
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default.a
  },

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('modals', ['closeModal']))
});

/***/ }),
/* 62 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Icon.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Icon.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-icon",

  // Props
  props: {
    icon: {
      type: String
    }
  }
});

/***/ }),
/* 63 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3768dcd5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Icon.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      "m-icon",
      ("m-icon--" + _vm.icon) ]
  }, [_c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [(_vm.icon === 'arrow-left') ? _c('path', {
    attrs: {
      "d": "M8.76 11l4.95 4.95a1 1 0 1 1-1.42 1.41l-5.65-5.65a1 1 0 0 1 0-1.42l5.65-5.65a1 1 0 0 1 1.42 1.41L8.76 11z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-next') ? _c('path', {
    attrs: {
      "d": "M18.194 11.988H1.07v-2h17.1L11.394 3.21l1.415-1.413L22 10.99l-.01.01.01.01-9.192 9.193-1.415-1.414 6.8-6.803z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-prev') ? _c('path', {
    attrs: {
      "d": "M3.806 12.09H20.93v-2H3.83l6.777-6.778-1.415-1.414L0 11.09l.01.01-.01.012 9.192 9.193 1.415-1.415-6.8-6.8z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'arrow-right') ? _c('path', {
    attrs: {
      "d": "M13.24 11L8.3 6.05a1 1 0 0 1 1.42-1.41l5.65 5.65a1 1 0 0 1 0 1.42l-5.65 5.65a1 1 0 0 1-1.42-1.41L13.24 11z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'carousel') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M3 3v16h6V3H3zM1 1h10v20H1V1zm12 0h5v20h-5V1zm2 18h1V3h-1v16zm4-18h2v20h-2V1z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'close') ? _c('path', {
    attrs: {
      "d": "M11 9L4.5 2.5 3 4l6.7 6.5L3 17.3l1.3 1.4L11 12l7 6.7 1.3-1.4-6.8-6.8L19 4l-1.3-1.6L11 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'code') ? _c('path', {
    attrs: {
      "d": "M12.825 16.675l1.75 1.75L22 11l-7.425-7.425-1.75 1.75L18.5 11l-5.675 5.675zm-3.65-11.35l-1.75-1.75L0 11l7.425 7.425 1.75-1.75L3.5 11l5.675-5.675z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'connect') ? _c('path', {
    attrs: {
      "d": "M19 5l-7 7-2-2 7-7h-6V1h10v10h-2V5zm0 9h2v7H7l-6-6V1h7v2H3v11l5 5h11v-5z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'download') ? _c('path', {
    attrs: {
      "d": "M5.437 5.5L3.72 7.215l7.285 7.285 7.285-7.284L16.573 5.5l-5.568 5.567L5.437 5.5zM1 18h20v2H1v-2z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "dropdown") ? _c('path', {
    attrs: {
      "d": "M9.08 9h3.84a1 1 0 0 1 .78 1.62l-1.92 2.4a1 1 0 0 1-1.56 0l-1.92-2.4A1 1 0 0 1 9.08 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'ellipsis') ? _c('path', {
    attrs: {
      "d": "M5.12 9l2.123 2.12-2.122 2.123L3 11.12 5.12 9zm6 0l2.123 2.12-2.122 2.123L9 11.12 11.12 9zm6 0l2.123 2.12-2.122 2.123L15 11.12 17.12 9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "eye") ? _c('path', {
    attrs: {
      "d": "M11 19c-3.58 0-6.86-2.09-9.84-6.26a3 3 0 0 1 0-3.48C4.14 5.09 7.42 3 11 3s6.86 2.09 9.84 6.26a3 3 0 0 1 0 3.48C17.86 16.91 14.58 19 11 19zm0-3a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0-2a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "eye-crossed") ? _c('path', {
    attrs: {
      "d": "M4.3 5.72l-2.5-2.5a1 1 0 1 1 1.42-1.41L20.2 18.78a1 1 0 0 1-1.41 1.41l-2.71-2.7a9.43 9.43 0 0 1-5.07 1.5c-3.58 0-6.86-2.08-9.84-6.25a3 3 0 0 1 0-3.49A20.02 20.02 0 0 1 4.3 5.72zm9.46 9.45l-1.47-1.46a3 3 0 0 1-4-4L6.83 8.24a5 5 0 0 0 6.93 6.93zM6.96 3.94A9.17 9.17 0 0 1 11 3c3.58 0 6.86 2.08 9.84 6.25a3 3 0 0 1 0 3.5 21.62 21.62 0 0 1-2.31 2.76l-2.82-2.82a5 5 0 0 0-6.4-6.4L6.96 3.94zM11.02 8A3 3 0 0 1 14 10.98L11.02 8z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'grid') ? _c('path', {
    attrs: {
      "d": "M3,3 L3,8 L8,8 L8,3 L3,3 Z M1,1 L10,1 L10,10 L1,10 L1,1 Z M12,1 L21,1 L21,10 L12,10 L12,1 Z M14,3 L14,8 L19,8 L19,3 L14,3 Z M1,12 L10,12 L10,21 L1,21 L1,12 Z M3,19 L8,19 L8,14 L3,14 L3,19 Z M12,12 L21,12 L21,21 L12,21 L12,12 Z M14,19 L19,19 L19,14 L14,14 L14,19 Z",
      "fill-rule": "nonzero"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'plus') ? _c('path', {
    attrs: {
      "d": "M12 10V4h-2v6H4v2h6v6h2v-6h6v-2h-6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'search') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M11.074 3.615l-3.71 1.537-1.537 3.71 1.537 3.71 3.71 1.537 3.71-1.54 1.536-3.71-1.536-3.71-3.71-1.537zm5.623-.376l2.33 5.62-2.33 5.623-5.623 2.33-5.624-2.33L3.12 8.86l2.33-5.62L11.074.91l5.623 2.33zM13.27 17.284l2.267-1.054 2.612 5.618-2.27 1.053-2.61-5.616z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-dribbble') ? _c('path', {
    attrs: {
      "d": "M21.028 11c0 .677-.07 1.354-.205 2.013-.132.643-.327 1.275-.583 1.88-.25.592-.56 1.164-.924 1.697-.358.53-.77 1.027-1.222 1.48-.453.45-.952.862-1.48 1.22-.536.36-1.11.67-1.702.923-.605.255-1.24.45-1.882.582-.66.136-1.338.205-2.017.205-.678 0-1.357-.07-2.016-.205-.644-.132-1.277-.327-1.882-.582-.593-.252-1.166-.562-1.7-.922-.53-.35-1.03-.77-1.482-1.22-.453-.45-.865-.95-1.223-1.48-.36-.53-.67-1.1-.923-1.69-.256-.6-.452-1.23-.585-1.88C1.068 12.36 1 11.68 1 11c0-.678.068-1.355.202-2.013.133-.644.33-1.277.585-1.88.252-.593.563-1.166.924-1.7.36-.53.77-1.025 1.23-1.48.45-.45.95-.86 1.48-1.218.54-.37 1.11-.68 1.7-.93.61-.26 1.24-.45 1.88-.58.66-.14 1.34-.2 2.02-.2.68 0 1.36.06 2.02.2.65.13 1.28.32 1.88.58.6.25 1.17.56 1.7.92.53.35 1.03.76 1.48 1.22.46.45.87.95 1.22 1.48.36.53.67 1.1.92 1.7.26.6.45 1.23.59 1.88.14.65.21 1.33.21 2.01zM7.365 3.276C4.98 4.4 3.2 6.596 2.645 9.24c.225 0 3.79.046 7.895-1.043-1.48-2.626-3.06-4.77-3.175-4.92zm3.884 6.236c-4.41 1.316-8.63 1.22-8.79 1.216 0 .09-.01.18-.01.272 0 2.194.83 4.194 2.19 5.706 0-.004 2.34-4.15 6.95-5.64.11-.038.22-.07.34-.103-.22-.485-.45-.972-.7-1.45zm5.41-4.92c-1.51-1.327-3.48-2.13-5.65-2.13-.7 0-1.37.083-2.02.238.13.172 1.73 2.3 3.19 4.982 3.22-1.208 4.44-3.06 4.46-3.09zm-4.14 7.786l-.06.018c-5.05 1.757-6.7 5.297-6.71 5.334 1.45 1.13 3.27 1.81 5.25 1.81 1.18 0 2.31-.24 3.34-.675-.13-.746-.63-3.36-1.83-6.484zm3.26 5.704c1.92-1.294 3.28-3.35 3.66-5.73-.18-.055-2.57-.812-5.33-.37 1.12 3.08 1.58 5.585 1.66 6.1zm-2.93-9.128c.19.407.39.822.56 1.238l.184.443c2.937-.37 5.832.252 5.955.277-.02-2.024-.744-3.882-1.944-5.337-.018.023-1.39 2.002-4.766 3.38z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-instagram') ? _c('path', {
    attrs: {
      "d": "M11 1c-2.715 0-3.056.012-4.122.06-1.065.05-1.792.218-2.428.465-.657.255-1.215.597-1.77 1.153-.557.556-.9 1.114-1.155 1.77-.248.637-.417 1.364-.465 2.428C1.013 7.943 1 8.284 1 11c0 2.716.012 3.056.06 4.122.05 1.065.218 1.792.465 2.427.256.65.597 1.21 1.153 1.77s1.114.9 1.77 1.15c.637.24 1.364.41 2.43.46 1.065.045 1.406.06 4.122.06s3.056-.015 4.122-.06c1.065-.05 1.792-.22 2.43-.468.656-.255 1.213-.598 1.77-1.154.555-.555.897-1.113 1.153-1.77.246-.636.415-1.363.465-2.428.047-1.068.06-1.408.06-4.124s-.013-3.058-.06-4.124c-.05-1.065-.22-1.79-.465-2.427-.256-.657-.598-1.215-1.154-1.77-.55-.556-1.11-.898-1.77-1.153-.63-.247-1.36-.416-2.43-.465C14.06 1.01 13.72 1 11 1zm-.896 1.802H11c2.67 0 2.987.01 4.042.058.975.044 1.504.207 1.856.344.467.18.8.398 1.15.748.35.35.566.683.748 1.15.137.352.3.88.344 1.856.048 1.054.06 1.37.06 4.04 0 2.668-.012 2.985-.06 4.04-.044.974-.207 1.503-.344 1.856-.18.466-.398.8-.748 1.148-.35.35-.683.567-1.15.748-.352.138-.88.3-1.856.345-1.054.048-1.37.058-4.04.058s-2.988-.01-4.042-.058c-.975-.045-1.504-.208-1.857-.345-.467-.18-.8-.398-1.15-.748-.35-.35-.567-.682-.748-1.15-.137-.35-.3-.88-.345-1.856-.047-1.054-.057-1.37-.057-4.04s.01-2.986.057-4.04c.045-.975.208-1.505.345-1.857.18-.47.398-.8.748-1.15.35-.35.683-.57 1.15-.75.353-.14.882-.3 1.857-.35.923-.04 1.28-.06 3.144-.06zm6.235 1.66c-.67 0-1.2.537-1.2 1.2 0 .663.53 1.2 1.2 1.2.66 0 1.2-.537 1.2-1.2 0-.662-.54-1.2-1.2-1.2zM11 5.866c-2.835 0-5.135 2.3-5.135 5.135 0 2.84 2.3 5.14 5.136 5.14 2.84 0 5.14-2.3 5.14-5.13s-2.3-5.132-5.13-5.132zm0 1.802c1.842 0 3.334 1.492 3.334 3.333 0 1.84-1.492 3.34-3.333 3.34-1.84 0-3.33-1.49-3.33-3.33 0-1.85 1.49-3.34 3.33-3.34z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-facebook') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M19.848 20.946H2.144c-.607 0-1.1-.49-1.1-1.098V2.144c0-.607.493-1.1 1.1-1.1h17.704c.607 0 1.098.493 1.098 1.1v17.704c0 .607-.49 1.098-1.098 1.098zm-5.07 0V13.24h2.586l.387-3.004h-2.97V8.32c0-.87.24-1.463 1.488-1.463h1.59v-2.69c-.274-.036-1.22-.12-2.317-.12-2.293 0-3.863 1.4-3.863 3.97v2.217H9.082v3.004h2.593v7.706h3.102z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'social-facebook') ? _c('path', {
    attrs: {
      "d": "M12.54 21V11h2.76l.37-3.45h-3.13V5.83c0-.9.09-1.38 1.38-1.38h1.73V1h-2.76C9.57 1 8.4 2.67 8.4 5.48v2.07H6.33V11H8.4v10h4.14z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'tick') ? _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9.017 13.475l8.268-8.267 1.768 1.767-10.03 10.03L9.017 17l-.005.007-5.993-5.993 1.765-1.768 4.23 4.23z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'form-error') ? _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 20C4.4772 20 0 15.5228 0 10S4.4772 0 10 0s10 4.4772 10 10-4.4772 10-10 10zM9 4v8h2V4H9zm0 10v2h2v-2H9z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'logout') ? _c('path', {
    attrs: {
      "fill-rule": "nonzero",
      "d": "M19.2 11.8H11a.8.8 0 0 1 0-1.6h8.2l-2.7-2.7a.8.8 0 0 1 1-1l4 4c.3.3.3.7 0 1l-4 4a.8.8 0 0 1-1-1l2.7-2.8zM14 2.2a.8.8 0 0 1 0 1.5H8c-.7 0-1.3.6-1.3 1.3v12c0 .7.6 1.3 1.3 1.3h6a.7.7 0 1 1 0 1.4H8A2.7 2.7 0 0 1 5.2 17V5c0-1.5 1.3-2.8 2.8-2.8h6z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === 'circle-plus') ? _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M11 22a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm1-12V6a1 1 0 0 0-2 0v4H6a1 1 0 0 0 0 2h4v4a1 1 0 0 0 2 0v-4h4a1 1 0 0 0 0-2h-4z"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon === "alert") ? _c('path', {
    attrs: {
      "fill": "#FFF",
      "fill-rule": "evenodd",
      "d": "M11 22a11 11 0 1 1 0-22 11 11 0 0 1 0 22zm-.64-9.24h1.28l.33-3.33V6.9h-1.95v2.52l.34 3.33zm.64 3.12a1.07 1.07 0 1 0 0-2.14 1.07 1.07 0 0 0 0 2.14z"
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 64 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6bbbe2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/modal/Close.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "link modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v("Close modal")]), _vm._v(" "), _c('module-icon', {
    attrs: {
      "icon": "close"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 65 */
/*!*************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Auth.vue ***!
  \*************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Auth.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_models_auth__ = __webpack_require__(/*! models/auth */ 17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form__ = __webpack_require__(/*! modules/Form */ 41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Logo__ = __webpack_require__(/*! modules/Logo */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Link__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Models


// Modules




// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-auth-login',

  // Components
  components: {
    ModuleForm: __WEBPACK_IMPORTED_MODULE_2_modules_Form___default.a,
    ModuleLogo: __WEBPACK_IMPORTED_MODULE_3_modules_Logo___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a
  },

  // Props
  props: {
    title: String,
    copy: String,
    successCopy: String,
    modal: Boolean,
    slug: {
      type: String,
      required: true
    },
    submit: String,
    success: {
      type: Function,
      default: function _default() {
        return function () {}; // eslint-disable-line no-empty-function
      }
    },
    fail: {
      type: Function,
      default: function _default() {
        return function () {}; // eslint-disable-line no-empty-function
      }
    }
  },

  // Data
  data: function data() {
    return {
      fields: {
        login: __WEBPACK_IMPORTED_MODULE_1_models_auth__["c" /* login */],
        registerPatient: __WEBPACK_IMPORTED_MODULE_1_models_auth__["e" /* registerPatient */],
        registerDentist: __WEBPACK_IMPORTED_MODULE_1_models_auth__["d" /* registerDentist */],
        reset: __WEBPACK_IMPORTED_MODULE_1_models_auth__["f" /* reset */],
        confirm: __WEBPACK_IMPORTED_MODULE_1_models_auth__["b" /* confirm */]
      },
      things: {
        registerDentistFields: this.registerDentistFields
      }
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel', 'getStatus']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('review', ['reviewNomenclature', 'reviewNomenclatureBySlug', 'reviewNomenclatureBySlugAndId', 'reviewRequests', 'reviewRequestsById']), {
    formId: function formId() {
      return '' + this.slug + (this.modal ? '-modal' : '');
    },
    model: function model() {
      return this.getModel(this.formId);
    },
    status: function status() {
      return this.getStatus(this.formId);
    },
    action: function action() {
      return __WEBPACK_IMPORTED_MODULE_1_models_auth__["a" /* _forms */].actions[this.slug];
    },
    submitSet: function submitSet() {
      return this.submit || __WEBPACK_IMPORTED_MODULE_1_models_auth__["a" /* _forms */].submit[this.slug] || '';
    },
    titleSet: function titleSet() {
      if (this.isPasswordSet) return 'Set Password';

      if (typeof this.title !== 'undefined') {
        return this.title || null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_models_auth__["a" /* _forms */].title[this.slug] || null;
    },
    copySet: function copySet() {
      if (this.isPasswordSet) return 'Welcome to VeriTooth! A VeriTooth account has already been created for you using your email address, please create a password below to complete your account set up';

      if (typeof this.copy !== 'undefined') {
        return this.copy || null;
      }
      return __WEBPACK_IMPORTED_MODULE_1_models_auth__["a" /* _forms */].copy[this.slug] || null;
    },
    hasFooter: function hasFooter() {
      return !!this.$slots.link || this.slug === 'login';
    },
    isPasswordSet: function isPasswordSet() {
      return this.$route.name === 'set-password';
    }
  }),

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('review', ['getNomenclature']), {
    requestAction: function requestAction() {
      return this.$store.dispatch('auth/' + this.action, this.model);
    }
  }),
  created: function created() {
    var _this = this;

    if (this.slug !== 'registerDentist') {
      return;
    }

    this.getNomenclature().then(function () {
      _this.fields.registerDentist.specialty.items = _this.reviewNomenclatureBySlug('specialties');
    });
  }
});

/***/ }),
/* 66 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Form.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Form.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_form_Fieldset__ = __webpack_require__(/*! modules/form/Fieldset */ 86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_form_Fieldset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_form_Fieldset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ui_ExpandButton__ = __webpack_require__(/*! ui/ExpandButton */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ui_ExpandButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ui_ExpandButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ui_Expander__ = __webpack_require__(/*! ui/Expander */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ui_Expander___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ui_Expander__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ui_Tooltip__ = __webpack_require__(/*! ui/Tooltip */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ui_Tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_ui_Tooltip__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex

// Services

// Modules


// UI



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-form',
  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_2_modules_Button___default.a,
    ModuleFormFieldset: __WEBPACK_IMPORTED_MODULE_3_modules_form_Fieldset___default.a,
    Expander: __WEBPACK_IMPORTED_MODULE_5_ui_Expander___default.a,
    UiTooltip: __WEBPACK_IMPORTED_MODULE_6_ui_Tooltip___default.a,
    ExpandButton: __WEBPACK_IMPORTED_MODULE_4_ui_ExpandButton___default.a
  },
  // Props
  props: {
    wide: Boolean,
    fields: Object,
    terms: Array,
    submit: String,
    hideSubmit: Boolean,
    noSubmit: Boolean,
    button: {
      type: String,
      default: 'light'
    },
    buttonSize: {
      type: String,
      default: 'm'
    },
    buttonDark: {
      type: Boolean,
      default: false
    },
    formId: String,
    action: Function,
    success: Function,
    fail: Function,
    doNotReset: Boolean
  },
  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getModel', 'getStatus', 'getValidations', 'getServerErrors']), {
    model: function model() {
      return this.getModel(this.formId);
    },
    status: function status() {
      return this.getStatus(this.formId);
    },
    validations: function validations() {
      return this.getValidations(this.formId);
    },
    serverErrors: function serverErrors() {
      return this.getServerErrors(this.formId);
    },
    invalid: function invalid() {
      var _this = this;

      var invalid = false;
      // TODO: Replace with Array prototype
      Object.keys(this.serverErrors).forEach(function (key) {
        if (_this.serverErrors[key]) {
          invalid = true;
        }
      });
      return invalid;
    }
  }),
  watch: {
    fields: {
      handler: function handler(fields) {
        var _this2 = this;

        Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(fields, function (key, field) {
          _this2.$store.commit('forms/updateFieldValidation', { // TODO: mapMutations
            form: _this2.formId,
            key: key,
            field: field
          });
        });
      },

      deep: true
    }
  },
  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', {
    'formEvent': 'event',
    'init': 'init',
    'onSubmit': 'onSubmit',
    'setLoading': 'setLoading',
    'setSuccess': 'setSuccess',
    'unsetLoading': 'unsetLoading'
  }), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["d" /* mapMutations */])('forms', ['updateValid']), {
    onFieldTouch: function onFieldTouch(id) {
      if (!this.$v.model[id]) return;

      this.$v.model[id].$touch();
    },
    onFieldReset: function onFieldReset(id) {
      if (!this.$v.model[id]) return;

      this.$v.model[id].$reset();
    },
    submitForm: function submitForm() {
      var _this3 = this;

      if (this.noSubmit) {
        return false;
      }
      this.setLoading(this.formId);
      var settle = function settle() {
        _this3.unsetLoading(_this3.formId);
      };
      var fail = function fail() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var errors = data.errors || [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = errors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var error = _step.value;

            _this3.formEvent({
              event: 'serverError',
              form: _this3.formId,
              field: error.field,
              error: error.message
            });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        _this3.fail ? _this3.fail(errors) || null : null; // eslint-disable-line no-unused-expressions
      };
      var success = function success(data) {
        _this3.success ? _this3.success(data) || null : null; // eslint-disable-line no-unused-expressions
        _this3.setSuccess(_this3.formId);
      };
      if (typeof this.action !== 'function') {
        return false;
      }

      this.action().then(function () {
        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        settle();
        if (response.status > 300) {
          fail(response.data);
        } else {
          success(response.data);
        }
      }).catch(function () {
        var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        settle();
        fail(response.data);
      });
    }
  }),
  // Lifecycle
  created: function created() {
    this.init({
      id: this.formId,
      fields: this.fields
    });
    this.$watch('$v', {
      handler: function handler(val) {
        this.updateValid({
          form: this.formId,
          value: val.model
        });
      },

      deep: true
    });
  },
  beforeMount: function beforeMount() {
    this.updateValid({
      form: this.formId,
      value: this.$v.model
    });
  },
  destroyed: function destroyed() {
    if (this.doNotReset !== true) {
      this.$store.commit('forms/resetForm', this.formId); // TODO: make action and map
      // setTimeout(() => {
      // }, 500);
    }
  },


  // Validations
  validations: function validations() {
    return {
      model: this.validations
    };
  }
});

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Button.vue ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Button.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_link__ = __webpack_require__(/*! services/link */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Spinner__ = __webpack_require__(/*! modules/Spinner */ 43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(/*! vue-scrollto */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Services


// Modules



// Other


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-button',

  // Components
  components: {
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default.a,
    ModuleSpinner: __WEBPACK_IMPORTED_MODULE_2_modules_Spinner___default.a
  },

  // Props
  props: {
    active: Boolean,
    hover: Boolean,
    disabled: Boolean,
    loading: Boolean,
    success: Boolean,
    button: {
      type: String
    },
    dark: Boolean,
    label: String,
    icon: String,
    link: [String, Object],
    query: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    negative: Boolean,
    title: String,
    size: {
      type: String
    }
  },

  // Data
  data: function data() {
    return {
      isActive: false,
      isHover: false
    };
  },

  computed: {
    linkType: function linkType() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["c" /* getLinkType */])(this.link);
    },
    linkTag: function linkTag() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["b" /* getLinkTag */])(this.link);
    },
    linkProps: function linkProps() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["a" /* createLinkProps */])(this.link, '', this.title, { query: this.query });
    }
  },

  // Methods
  methods: {
    onMouseEnter: function onMouseEnter() {
      this.isHover = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.isHover = false;
    },
    onMouseDown: function onMouseDown() {
      this.isActive = true;
    },
    onMouseUp: function onMouseUp() {
      this.isActive = false;
      this.isHover = false;
    },
    onClick: function onClick(e) {
      if (this.linkType === 'anchor') {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default.a.scrollTo(this.link, 500, {});
      }
    }
  },

  // Lifecycle
  mounted: function mounted() {
    document.addEventListener('mouseup', this.onMouseUp, false);
  },
  destroyed: function destroyed() {
    document.removeEventListener('mouseup', this.onMouseUp, false);
  }
});

/***/ }),
/* 83 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Spinner.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Spinner.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_icons_spinner_svg_inline__ = __webpack_require__(/*! images/icons/spinner.svg?inline */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_images_icons_spinner_svg_inline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_images_icons_spinner_svg_inline__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Inline


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-spinner',

  // Components
  components: {
    InlineImageIconsSpinner: __WEBPACK_IMPORTED_MODULE_0_images_icons_spinner_svg_inline___default.a
  },

  // Props
  props: {
    active: Boolean,
    floating: Boolean
  }
});

/***/ }),
/* 84 */
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2156f126"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Spinner.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      "m-spinner",
      {
        'm-spinner--active': _vm.active,
        'm-spinner--floating': _vm.floating,
      }
    ],
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('inline-image-icons-spinner', {
    staticClass: "m-spinner__svg"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 85 */
/*!***************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7298420e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Button.vue ***!
  \***************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: [
      'btn',
      _vm.icon ? 'btn--' + (_vm.negative ? 'negative' : 'positive') : '',
      'btn--' + (_vm.button || 'secondary'),
      'btn--' + (_vm.size || 'm'),
      {
        'btn--icon': _vm.icon,
        'btn--idle': (!_vm.hover && !_vm.isHover && !_vm.active && !_vm.isActive) || (_vm.loading),
        'btn--hover': (_vm.hover || _vm.isHover || _vm.active || _vm.isActive) && !_vm.disabled && !_vm.loading,
        'btn--active': (_vm.active || _vm.isActive) && !_vm.disabled && !_vm.hover && !_vm.loading,
        'btn--disabled': !_vm.success && !_vm.loading && _vm.disabled,
        'btn--loading': _vm.loading,
        'btn--success': _vm.success,
        'btn--dark': _vm.dark,
      }
    ],
    attrs: {
      "disabled": _vm.disabled || _vm.loading || _vm.success
    },
    on: {
      "mouseover": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onMouseDown($event)
      },
      "click": _vm.onClick
    },
    nativeOn: {
      "mouseover": function($event) {
        _vm.onMouseEnter($event)
      },
      "mouseleave": function($event) {
        _vm.onMouseLeave($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        _vm.onMouseDown($event)
      }
    }
  }, 'component', _vm.linkProps, false), [_c('b', {
    staticClass: "btn__bg",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('module-spinner', {
    class: "btn__spinner",
    attrs: {
      "active": _vm.loading
    }
  }), _vm._v(" "), _c('module-icon', {
    class: "btn__success",
    attrs: {
      "icon": "tick"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn__inner"
  }, [_c('span', {
    staticClass: "btn__content"
  }, [_c('span', {
    staticClass: "btn__label"
  }, [(_vm.label) ? [_vm._v(_vm._s(_vm.label))] : _vm._t("default")], 2), (_vm.icon) ? _c('module-icon', {
    class: "btn__icon",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 86 */
/*!*****************************************************!*\
  !*** ./client/components/modules/form/Fieldset.vue ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Fieldset.vue */ 87),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-117b9cb2"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Fieldset.vue */ 104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/form/Fieldset.vue ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/form/Fieldset.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button__ = __webpack_require__(/*! modules/Button */ 10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_modules_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_form_Field__ = __webpack_require__(/*! modules/form/Field */ 90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_modules_form_Field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_modules_form_Field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_form_Errors__ = __webpack_require__(/*! modules/form/Errors */ 93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_form_Errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_form_Errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_transitions_Fade__ = __webpack_require__(/*! transitions/Fade */ 100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_transitions_Fade___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_transitions_Fade__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Modules







// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-form-fieldset',

  // Components
  components: {
    ModuleButton: __WEBPACK_IMPORTED_MODULE_2_modules_Button___default.a,
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_3_modules_Icon___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a,
    ModuleFormField: __WEBPACK_IMPORTED_MODULE_5_modules_form_Field___default.a,
    ModuleFormErrors: __WEBPACK_IMPORTED_MODULE_6_modules_form_Errors___default.a,
    TransitionsFade: __WEBPACK_IMPORTED_MODULE_7_transitions_Fade___default.a
  },

  // Props
  props: {
    field: Object,
    fieldId: String,
    formId: String,
    serverError: {
      type: String,
      default: ''
    },
    fileButton: String
  },

  // Data
  data: function data() {
    return {
      focus: false,
      toggle: false,
      preview: [],
      previewEncoded: []
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']), Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('forms', ['getStatus', 'getModel', 'getForm']), {
    model: function model() {
      return this.getModel(this.formId);
    },
    fieldType: function fieldType() {
      var type = this.field.type || 'text';
      if (type === 'radio') {
        return this.field.boolean || (this.field.items || []).length === 1 ? 'checkbox' : type;
      }
      return type;
    },
    required: function required() {
      return (this.field.validations || {}).required;
    },
    value: function value() {
      return this.model[this.fieldId];
    },
    button: function button() {
      return this.field.button || 'tertiary';
    },
    hasValue: function hasValue() {
      if (this.fieldType === 'number') {
        return this.value || this.value === 0;
      }
      return !!this.value;
    },
    valid: function valid() {
      return this.getForm(this.formId).valid[this.fieldId] || {};
    },
    labelTag: function labelTag() {
      return this.isType('toggle') ? 'legend' : 'label';
    },
    conditionalTrue: function conditionalTrue() {
      return this.field.conditional ? this.field.conditional(this.model) : null;
    },
    isPlaceholder: function isPlaceholder() {
      if (this.isType('select')) {
        return !this.value && this.value !== '';
      }
      return !this.hasValue && !this.focus && !this.isType('toggle') && !this.valid.$error && !this.serverError;
    },
    fieldValidations: function fieldValidations() {
      return this.field.validations || {};
    },
    numberMin: function numberMin() {
      if (this.fieldValidations.min) {
        return this.fieldValidations.min;
      }
      var min = (this.fieldValidations.between || [])[0];
      return min || min === 0 ? 0 : false || false;
    },
    numberMax: function numberMax() {
      if (this.fieldValidations.max) {
        return this.fieldValidations.max;
      }
      return (this.fieldValidations.between || [])[1] || false;
    },
    numberStep: function numberStep() {
      return this.field.step || false;
    },
    status: function status() {
      return this.getStatus(this.formId);
    },
    isReadonly: function isReadonly() {
      return this.field.hidden || this.field.readonly || this.status.loading || this.status.success;
    },
    previewImages: function previewImages() {
      if (this.fieldType !== 'file') {
        return [];
      }

      if (this.field.preview && this.previewEncoded.length) {
        return this.previewEncoded;
      }

      var arr = this.field.preview ? this.previewEncoded || [] : [];
      var existing = this.field.existing || '';

      if (existing) {
        arr = [].concat(_toConsumableArray(arr), _toConsumableArray(this.$store.getters[existing]));
      }

      return arr || [];
    }
  }),
  watch: {
    conditionalTrue: function conditionalTrue(value) {
      this.checkConditional(value);
    },
    preview: function preview(_preview) {
      var _this = this;

      this.previewEncoded = [];

      Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["b" /* arrayLoop */])(_preview, function (index, file) {
        var reader = new FileReader();
        var name = file.name;

        reader.addEventListener('load', function () {
          _this.previewEncoded.push({
            image: reader.result,
            name: name
          });
        }, false);

        if (file) {
          if (/\.(jpe?g|png|gif|pdf)$/i.test(file.name)) {
            reader.readAsDataURL(file);
          }
        }
      });
    }
  },

  // Methods
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])('forms', {
    'formEvent': 'event'
  }), {
    isType: function isType(fieldType) {
      if (fieldType === 'toggle') {
        return Object(__WEBPACK_IMPORTED_MODULE_1_services_array__["a" /* arrayIncludes */])(['checkbox', 'radio', 'boolean'], this.fieldType);
      }
      return this.fieldType === fieldType;
    },
    onChange: function onChange(args) {
      if (args.files) {
        this.preview = args.files;
      }

      this.$emit('fieldTouch', this.fieldId);

      this.formEvent({
        event: 'serverError',
        form: this.formId,
        field: this.fieldId,
        error: ''
      });
    },
    onFocusBlur: function onFocusBlur(focus) {
      this.focus = focus;

      if (focus === false) {
        this.onFieldTouch(this.fieldId);
      }
    },
    onKeydown: function onKeydown(event) {
      if (event.key === 'e' && this.fieldType === 'number') {
        event.preventDefault();
      }
    },
    onFieldTouch: function onFieldTouch(id) {
      this.$emit('fieldTouch', id);
    },
    checkConditional: function checkConditional(value) {
      if (value === null) {
        return false;
      }

      this.$store.commit('forms/TOGGLE_VALIDATION', { // TODO: mapMutations
        form: this.formId,
        key: this.fieldId,
        field: this.field,
        type: this.fieldType,
        value: value
      });

      if (!value) {
        this.$store.commit('forms/updateValue', { // TODO: mapMutations
          form: this.formId,
          field: this.fieldId,
          value: null // TODO: Make based on field type
        });

        this.$emit('fieldReset', this.fieldId);
      } else if (this.field.value && value) {
        this.$store.commit('forms/updateValue', { // TODO: mapMutations
          form: this.formId,
          field: this.fieldId,
          value: this.field.value // TODO: Make based on field type
        });
      }
    },
    focusField: function focusField(e) {
      var target = e.target || {};
      var targetData = target.dataset || {};

      if (typeof targetData.passwordToggle !== 'undefined') return false;

      this.$refs.field.$el.focus();
    }
  }),

  // Lifecycle
  mounted: function mounted() {
    this.checkConditional(this.conditionalTrue);
  }
});

/***/ }),
/* 88 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Link.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Link.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_link__ = __webpack_require__(/*! services/link */ 33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto__ = __webpack_require__(/*! vue-scrollto */ 14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Services


// Modules


// Other


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-link',

  // Components
  components: {
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default.a
  },

  // Props
  props: {
    color: String,
    label: String,
    external: {
      type: Boolean,
      default: false
    },
    link: [String, Object],
    title: String,
    icon: String,
    iconNegative: Boolean,
    noUnderline: Boolean
  },

  // Data
  computed: {
    linkType: function linkType() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["c" /* getLinkType */])(this.link);
    },
    linkTag: function linkTag() {
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["b" /* getLinkTag */])(this.link);
    },
    linkProps: function linkProps() {
      var options = {
        external: this.external || false
      };
      return Object(__WEBPACK_IMPORTED_MODULE_0_services_link__["a" /* createLinkProps */])(this.link, this.labelSet, this.title, options);
    },
    labelSet: function labelSet() {
      if (this.$slots.default && (this.$slots.default || [])[0]) {
        return this.$slots.default[0].text;
      }
      return this.label || '';
    },
    linkClass: function linkClass() {
      return ['link', this.color && this.color !== 'inherit' ? 'link--' + this.color : '', {
        'link--anchor': this.linkType === 'anchor',
        'link--external': this.linkType === 'a',
        'link--internal': this.linkType === 'router-link',
        'link--no-underline': this.noUnderline,
        'link--icon': this.icon
      }];
    }
  },

  // Methods
  methods: {
    onClick: function onClick(e) {
      if (this.linkType === 'anchor') {
        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_2_vue_scrollto___default.a.scrollTo(this.link, 500, {});
      }
    }
  }
});

/***/ }),
/* 89 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aadab054"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Link.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.linkTag, _vm._b({
    tag: "component",
    class: _vm.linkClass,
    on: {
      "click": _vm.onClick
    }
  }, 'component', _vm.linkProps, false), [(_vm.icon && !_vm.iconNegative) ? _c('module-icon', {
    class: [
      "link__icon",
      "link__icon--positive" ],
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), ((_vm.$slots.default || [])[0]) ? _vm._t("default") : [_vm._v(_vm._s(_vm.labelSet))], (_vm.icon && _vm.iconNegative) ? _c('module-icon', {
    class: [
      "link__icon",
      "link__icon--negative" ],
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 90 */
/*!**************************************************!*\
  !*** ./client/components/modules/form/Field.vue ***!
  \**************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Field.vue */ 91),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/*!************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/form/Field.vue ***!
  \************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/form/Field.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autosize__ = __webpack_require__(/*! autosize */ 92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Link__);

// Vuex


// Dependencies


// Services


// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "module-form-field",

  // Components
  components: {
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_3_modules_Icon___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a
  },

  // Props
  props: {
    id: String,
    field: Object,
    formId: String,
    toggle: Boolean
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])("forms", ["getModel"]), {
    isResizeable: function isResizeable() {
      var field = this.field;

      return field.type === "textarea" && field.resize === true;
    },
    storeValue: function storeValue() {
      var model = this.getModel(this.formId) || {};
      return model[this.id] || null;
      // return this.$store.state.forms[this.formId].model[this.id];
    }
  }),
  watch: {
    isResizeable: function isResizeable(val) {
      if (this.field.type === "textarea") {
        if (val) {
          __WEBPACK_IMPORTED_MODULE_1_autosize___default()(this.$el);
        } else {
          __WEBPACK_IMPORTED_MODULE_1_autosize___default.a.destroy(this.$el);
        }
      }
    },
    storeValue: function storeValue(val) {
      if (this.field.type === "file" && val.length === 0) {
        var resetValue = [];

        if (this.field.existing && this.$store.getters[this.field.existing]) {
          resetValue = this.$store.getters[this.field.existing];
        }

        this.$emit("change", {
          files: resetValue
        });
      }
    }
  },

  // Render
  render: function render(createElement) {
    var self = this;

    var field = this.field;
    var fieldType = field.type;
    var attrs = {};
    var children = [];

    var tag = "input";
    var value = this.storeValue;

    var eventObj = {
      event: "input",
      form: this.formId,
      field: this.id
    };

    if (!value && fieldType === "color") {
      value = "#ae0000"; // TODO: Var
    } else if (fieldType === "select" && Array.from(field.items || []).length === 1) {
      // If there is only 1 item in the select drop down then set that as the value
      value = field.items[0].value;
    } else if (fieldType === "radio") {
      var disabledItems = Array.from(field.items || []).reduce(function (acc, item) {
        return acc + (item.disabled ? 1 : 0);
      }, 0);
      if (Array.from(field.items || []).length - disabledItems === 1) {
        value = field.items.find(function (item) {
          return !item.disabled;
        }).value;
      }
    } else if (fieldType === "number" && value === 0) {
      value = "0";
    } else if (!value) {
      value = "";
    }

    var dataObj = {
      domProps: {
        name: this.id
      },
      class: [],
      on: {
        input: function input(event) {
          var newValue = event.target.value;

          if (field.contentType === "Number" || fieldType === "number") {
            // Keep zero as a string to allow the FE to show it, getModel() will convert this back to a number
            newValue = newValue === "0" ? newValue : parseInt(newValue, 10);
          }

          var change = self.value === newValue;

          self.value = newValue;

          self.$store.dispatch("forms/event", Object.assign({}, eventObj, {
            value: newValue,
            change: change
          }));

          if (field.type === "textarea" && field.resize) {
            __WEBPACK_IMPORTED_MODULE_1_autosize___default.a.update(self.$el);
          }
        },
        focus: function focus() {
          self.$emit("focusBlur", true);
        },
        blur: function blur() {
          self.$emit("focusBlur", false);
        },
        change: function change() {
          var args = {};

          if (field.type === "file") {
            var files = self.$el.files;

            if (!files.length && self.field.existing && self.$store.getters[self.field.existing]) {
              files = self.$store.getters[self.field.existing];
            }

            self.$store.dispatch("forms/event", Object.assign({}, eventObj, {
              value: files.length ? files : []
            }));

            args.files = files;
          }

          self.$emit("change", args);
        }
      }
    };

    if (field.placeholder) {
      dataObj.domProps.placeholder = field.placeholder;
    }

    if (value && fieldType !== "file") {
      self.$store.dispatch("forms/event", Object.assign({}, eventObj, {
        value: value
      }));
    }

    if (fieldType === "file") {
      // const validations = self.field.validations || {};
      // const maxLength = validations.maxLength || 1;
      if (field.multiple) {
        dataObj.domProps.multiple = true;
      }
    } else {
      dataObj.domProps.value = value;
    }

    if (field.autoComplete === false) {
      dataObj.domProps.autocomplete = "off";
    } else if (field.autoComplete) {
      dataObj.domProps.autocomplete = field.autoComplete;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_2_services_array__["a" /* arrayIncludes */])(["checkbox", "radio", "boolean"], fieldType)) {
      dataObj.domProps.id = this.id;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_2_services_array__["a" /* arrayIncludes */])(["textarea", "select", "checkbox", "radio", "boolean"], fieldType)) {
      dataObj.domProps.type = this.toggle && fieldType === "password" ? "text" : fieldType || "text";
    }

    if (fieldType === "textarea") {
      tag = "textarea";
      var minRows = 3;
      var maxRows = 10;

      var rows = field.rows || 4;

      dataObj.domProps.rows = rows >= maxRows ? maxRows : rows <= minRows ? minRows : rows;

      if (field.resize) {
        __WEBPACK_IMPORTED_MODULE_1_autosize___default()(this.$el);
      }
    }

    if (fieldType === "select") {
      tag = "select";

      var items = field.items || [];
      var itemsArr = [];

      items.forEach(function (v) {
        var isStr = typeof v === "string";
        var value = isStr ? v : v.value;
        var label = isStr ? v : v.option;
        var itemAttrs = {
          value: value
        };

        itemsArr.push(createElement("option", { attrs: itemAttrs }, label));
      });

      var placeholderAttrs = {
        value: "_NULL",
        disabled: "disabled"
      };

      if (!value) dataObj.domProps.value = "_NULL";

      children.push(createElement("option", { attrs: placeholderAttrs }, "" + (field.placeholder || "Select")));

      Array.prototype.push.apply(children, itemsArr);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_2_services_array__["a" /* arrayIncludes */])(["checkbox", "radio", "boolean"], fieldType)) {
      tag = "fieldset";

      var isCheckbox = fieldType === "checkbox";
      var isRadio = fieldType === "radio";
      var isBoolean = fieldType === "boolean";

      var booleanItems = [{
        option: field.label,
        value: true
      }];
      var _items = isBoolean ? booleanItems : field.items || [];

      _items.forEach(function (v) {
        var inputAttrs = {
          class: ["visuallyhidden"],
          domProps: {
            name: self.id,
            checked: isCheckbox ? value.indexOf(v.value) >= 0 : value === v.value
          },
          on: {
            change: function change(event) {
              if (field.readonly) {
                event.preventDefault();
                return false;
              }

              if (isCheckbox) {
                var val = event.target.value;
                var checked = value.indexOf(val) >= 0;

                if (!checked) {
                  value.push(val);
                } else {
                  var i = value.indexOf(val);
                  if (i >= 0) {
                    value.splice(i, 1);
                  }
                }

                self.$store.dispatch("forms/event", {
                  event: "input",
                  form: self.formId,
                  field: self.id,
                  value: value
                });

                self.$emit("fieldTouch", self.id);
              }

              if (isRadio || isBoolean) {
                if (isBoolean) {
                  value = !value;
                } else if (v.value === value) {
                  value = null;
                } else {
                  value = v.value;
                }

                self.$store.dispatch("forms/event", Object.assign({}, eventObj, {
                  value: value
                }));
              }
            }
          },
          attrs: {
            type: "checkbox",
            value: v.value,
            disabled: v.disabled ? "disabled" : false
          }
        };

        var input = createElement("input", inputAttrs);

        var isChecked = false;
        if (isCheckbox) {
          isChecked = value.indexOf(v.value) >= 0;
        } else if (isBoolean) {
          isChecked = !!value;
        } else {
          isChecked = v.value === value;
        }

        var labelAttrs = {
          class: ["form__checkbox", {
            "form__checkbox--disabled": v.disabled,
            "is--checked": isChecked,
            "is--readonly": field.readonly
          }]
        };

        var labelIcon = createElement(__WEBPACK_IMPORTED_MODULE_3_modules_Icon___default.a, {
          props: {
            icon: "tick"
          }
        });

        var checkboxToggle = createElement("span", {
          class: ["form__toggle", "form__toggle--" + fieldType, {
            "is--checked": isChecked
          }]
        }, [isCheckbox ? labelIcon : ""]);

        var spanAttrs = {
          class: ["form__label", "form__label--checkbox"]
        };

        var labelContent = [v.option];

        if (self.id === "terms" && fieldType === "boolean") {
          // labelChildren.push(createElement(`span`, spanAttrs))
          labelContent = [createElement("span", {}, ["Agree to\xA0", createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a, {
            props: {
              link: "terms",
              label: "T&Cs",
              external: true
            }
          }), "\xA0and\xA0", createElement(__WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a, {
            props: {
              link: "privacy",
              label: "Privacy Policy",
              external: true
            }
          })])];
        }

        var labelChildren = [input, createElement("span", spanAttrs, labelContent), checkboxToggle];

        var label = createElement("label", labelAttrs, labelChildren);

        children.push(label);
      });
    }

    dataObj.attrs = attrs;

    return createElement(tag, dataObj, children);
  }
});

/***/ }),
/* 92 */,
/* 93 */
/*!***************************************************!*\
  !*** ./client/components/modules/form/Errors.vue ***!
  \***************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Errors.vue */ 94),
  /* template */
  __webpack_require__(/*! !../../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-9c4d57ac"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Errors.vue */ 99),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/form/Errors.vue ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/form/Errors.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_services_array__ = __webpack_require__(/*! services/array */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_transitions_ExpandHeight__ = __webpack_require__(/*! transitions/ExpandHeight */ 95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_transitions_ExpandHeight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_transitions_ExpandHeight__);
//
//
//
//
//
//
//
//

// Services


// Transitions


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-form-errors',

  // Components
  components: {
    TransitionExpandHeight: __WEBPACK_IMPORTED_MODULE_1_transitions_ExpandHeight___default.a
  },

  // Props
  props: {
    serverError: String,
    errors: Object,
    messages: Object,
    label: {
      type: String,
      default: 'This field'
    }
  },

  // Data
  data: function data() {
    return {
      hasErrors: false,
      error: this.label + ' is invalid'
    };
  },

  computed: {
    show: function show() {
      return this.serverError || this.hasErrors;
    }
  },
  watch: {
    errors: {
      handler: function handler(errors) {
        var label = this.label;
        var params = errors.$params || {};
        var min = (params.min || {}).min || 0;
        var max = (params.max || {}).max || 0;
        var minLength = (params.minLength || {}).min || 0;
        var maxLength = (params.maxLength || {}).max || 0;

        var map = {
          required: 'Required',
          url: 'Invalid URL',
          email: 'Invalid email',
          min: min + ' min.',
          minLength: label + ' must contain at least ' + minLength + ' characters',
          max: max + ' max.',
          maxLength: maxLength + ' character(s) max.',
          match: 'Fields do not match'
        };

        var error = '';

        var messages = this.messages || {};

        Object(__WEBPACK_IMPORTED_MODULE_0_services_array__["b" /* arrayLoop */])(map, function (key, msg) {
          if (errors[key] === false && !error) {
            error = messages[key] || msg;
          }
        });

        if (errors.$error) {
          this.error = error || label + ' is invalid';
          this.hasErrors = true;
        } else {
          this.hasErrors = false;
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 95 */
/*!********************************************************!*\
  !*** ./client/components/transitions/ExpandHeight.vue ***!
  \********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-0151f966","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ExpandHeight.vue */ 96)

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ExpandHeight.vue */ 97),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0151f966"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ExpandHeight.vue */ 98),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0151f966","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/transitions/ExpandHeight.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/*!******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/transitions/ExpandHeight.vue ***!
  \******************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/transitions/ExpandHeight.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "transitions-expand-height",

  data: function data() {
    return {
      open: false
    };
  },


  // Methods
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.style.display = "block";
      el.style.overflow = "hidden";
      el.style.height = "auto";
      el.style.opacity = 0;

      var height = el.clientHeight;

      el.style.height = "0px";

      setTimeout(function () {
        el.style.height = height + "px";

        setTimeout(function () {
          el.style.height = "auto";
          el.style.opacity = 1;
        }, 150);
      });
    },
    beforeLeave: function beforeLeave(el) {
      el.style.height = el.clientHeight + "px";
      el.style.display = "block";
      el.style.opacity = 0;

      setTimeout(function () {
        setTimeout(function () {
          el.style.height = "0px";
        });
      }, 150);
    }
  }
});

/***/ }),
/* 98 */
/*!*************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0151f966"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/transitions/ExpandHeight.vue ***!
  \*************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "transition-expand-height",
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "before-leave": _vm.beforeLeave
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 99 */
/*!********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c4d57ac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/form/Errors.vue ***!
  \********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-expand-height', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    class: ["form__errors", "errors"]
  }, [_c('li', {
    staticClass: "errors__item small"
  }, [_vm._v(_vm._s(_vm.serverError || _vm.error))])])])
},staticRenderFns: []}

/***/ }),
/* 100 */
/*!************************************************!*\
  !*** ./client/components/transitions/Fade.vue ***!
  \************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-compiler/index?{"id":"data-v-4d2c0701","scoped":false,"hasInlineConfig":false}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Fade.vue */ 101)

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Fade.vue */ 102),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4d2c0701"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Fade.vue */ 103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4d2c0701","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/transitions/Fade.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/transitions/Fade.vue ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/transitions/Fade.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "transitions-fade"

});

/***/ }),
/* 103 */
/*!*****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2c0701"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/transitions/Fade.vue ***!
  \*****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "transition-fade",
      "mode": "out-in"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 104 */
/*!**********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-117b9cb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/form/Fieldset.vue ***!
  \**********************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.field.conditional || (_vm.field.conditional && _vm.conditionalTrue)) ? _c('div', {
    class: [
      'form__fieldset',
      {
        'fieldset--is-dirty': _vm.valid.$dirty || _vm.value,
        'fieldset--is-dirty-select': !_vm.isPlaceholder,
        'fieldset--is-focus': _vm.focus && !_vm.isReadonly,
        'fieldset--has-errors': _vm.valid.$error || _vm.serverError,
        'fieldset--is-conditional': _vm.conditionalTrue,
        'fieldset--is-hidden': _vm.field.hidden,
        'form__fieldset--is-readonly': _vm.isReadonly,
        'form__fieldset--conditional': _vm.field.conditional,
      }
    ],
    attrs: {
      "data-form-fieldset": _vm.fieldId
    }
  }, [_c('div', {
    class: [
      "form__label-wrapper",
      {
        'form__label-wrapper--hidden': _vm.field.labelHidden,
      } ]
  }, [(!_vm.field.labelHidden) ? _c(_vm.labelTag, {
    tag: "component",
    class: [
      "form__label",
      {
        'form__label--is-placeholder': _vm.isPlaceholder,
        'form__label--hidden': _vm.field.noLabel || _vm.fieldType === "boolean",
      } ],
    attrs: {
      "for": _vm.fieldId
    }
  }, [_vm._v("\n      " + _vm._s(_vm.field.label) + "\n      "), (_vm.fieldType === "file") ? _c('span', [_vm._v(_vm._s(("(" + (_vm.required ? "Required" : "Optional") + ")")))]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: [
      'form__field',
      ("form__field--" + _vm.fieldType),
      {
        'form__field--toggle': _vm.isType("toggle"),
      }
    ],
    on: {
      "click": function($event) {
        _vm.focusField($event)
      }
    }
  }, [(!_vm.isType("toggle")) ? _c('b', {
    class: [
      'form__field-bg',
      {
        'form__field-bg--is-focus': _vm.focus && !_vm.isReadonly,
        'form__field-bg--has-errors': _vm.valid.$error || _vm.serverError,
        'form__field-bg--is-readonly': _vm.isReadonly,
      }
    ]
  }) : _vm._e(), _vm._v(" "), (_vm.isType("select")) ? _c('module-icon', {
    staticClass: "form__select-arrow",
    attrs: {
      "icon": "dropdown"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.icon) ? _c('b', {
    class: [
      "form__icon",
      ("form__icon--" + (_vm.field.icon)) ]
  }, [_c('module-icon', {
    attrs: {
      "icon": _vm.field.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.field.prefix) ? _c('span', {
    class: "form__prefix",
    domProps: {
      "innerHTML": _vm._s(_vm.field.prefix)
    }
  }) : _vm._e(), _vm._v(" "), _c('module-form-field', {
    ref: "field",
    class: [
      'form__input',
      'form__input--' + _vm.fieldType,
      {
        'form__input--toggle': _vm.isType("toggle"),
        'form__input--prefix': _vm.field.prefix,
        'form__input--readonly': _vm.isReadonly,
      }
    ],
    attrs: {
      "id": _vm.fieldId,
      "field": _vm.field,
      "form-id": _vm.formId,
      "min": _vm.numberMin,
      "max": _vm.numberMax,
      "step": _vm.numberStep,
      "readonly": _vm.isReadonly,
      "toggle": _vm.toggle
    },
    on: {
      "focusBlur": _vm.onFocusBlur,
      "change": _vm.onChange,
      "fieldTouch": _vm.onFieldTouch
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.onKeydown($event)
      }
    }
  }), _vm._v(" "), (_vm.isType('textarea') && _vm.field.counter) ? _c('span', {
    class: [
      "small",
      "form__counter" ]
  }, [_vm._v("\n      " + _vm._s((_vm.value || '').length) + _vm._s((_vm.field.validations || {}).maxLength ? '/' + (_vm.field.validations || {}).maxLength : '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.isType("file")) ? _c('module-button', {
    attrs: {
      "type": "button",
      "button": _vm.button
    }
  }, [(_vm.previewEncoded.length) ? _c('span', [_vm._v("Remove File")]) : _c('span', [_vm._v("Choose File")])]) : _vm._e(), _vm._v(" "), (_vm.isType("file")) ? _c('span', {
    class: "form__input form__input--faux form__input--file-faux"
  }, [(!_vm.previewEncoded.length) ? [_c('module-icon', {
    attrs: {
      "icon": "circle-plus"
    }
  })] : (_vm.previewEncoded.length === 1 && _vm.previewEncoded[0].name) ? [_vm._v("\n        " + _vm._s(_vm.previewEncoded[0].name) + "\n        ")] : [_vm._v(_vm._s(_vm.previewEncoded.length) + " files selected")]], 2) : _vm._e(), _vm._v(" "), (_vm.isType('color')) ? _c('span', {
    class: "p form__input form__input--faux"
  }, [_c('b', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('b', {
    style: ({
      backgroundColor: _vm.value
    })
  })]), _c('span', [_vm._v(_vm._s(_vm.value))])]) : _vm._e(), _vm._v(" "), (_vm.field.type === "password") ? _c('module-icon', {
    class: [
      "form__toggle-password",
      {
        'form__toggle-password--visible': _vm.toggle,
      } ],
    attrs: {
      "icon": !_vm.toggle ? "eye-crossed" : "eye",
      "title": ((_vm.toggle ? "Hide" : "Reveal") + " password"),
      "data-password-toggle": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle = !_vm.toggle
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isType("file")) ? _c('div', {
    staticClass: "form-preview"
  }, _vm._l((_vm.previewImages), function(image, index) {
    return _c('div', {
      key: index,
      class: "form-preview__item"
    }, [_c('span', {
      class: "form-preview__image",
      style: ({
        backgroundImage: ("url(" + (image.thumbnail || image.image) + ")"),
      })
    }), _vm._v(" "), (_vm.field.remove && image.id) ? _c('span', {
      class: "form-preview__remove",
      on: {
        "click": function($event) {
          _vm.$store.dispatch(_vm.field.remove, image.id)
        }
      }
    }, [_c('span', {
      staticClass: "visuallyhidden"
    }, [_vm._v("Delete image")]), _vm._v(" "), _c('module-icon', {
      attrs: {
        "icon": "cross"
      }
    })], 1) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), (_vm.field.forgot && !_vm.isAuthenticated) ? _c('div', {
    staticClass: "form__forgot small"
  }, [_c('module-link', {
    attrs: {
      "label": "Forgotten Password?",
      "link": "authReset",
      "tabindex": "-1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.field.helper && !_vm.valid.$error) ? _c('div', {
    staticClass: "form__helper small mb0 mt0"
  }, [(_vm.fieldValidations.max && _vm.fieldValidations.min) ? [_vm._v(_vm._s(((_vm.fieldValidations.min) + "–" + (_vm.fieldValidations.max) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")))] : (_vm.fieldValidations.max) ? [_vm._v(_vm._s(((_vm.field.label) + " can contain " + (_vm.fieldValidations.max) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")) + " "), _c('abbr', {
    attrs: {
      "title": "maximum"
    }
  }, [_vm._v("max.")])] : (_vm.fieldValidations.min) ? [_vm._v(_vm._s(((_vm.field.label) + " must contain at least " + (_vm.fieldValidations.min) + " " + (_vm.isType("file") ? "file" : "character") + "(s)")))] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('module-form-errors', {
    attrs: {
      "server-error": _vm.serverError,
      "errors": _vm.valid,
      "label": _vm.field.errorLabel || _vm.field.label,
      "messages": _vm.field.errorMessages
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 105 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-7bc0e323","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/ExpandButton.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/ExpandButton.vue ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/ExpandButton.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      expanded: false
    };
  },

  methods: {
    handleExpansion: function handleExpansion(event) {
      this.expanded = event.detail.expanded;
    }
  }
});

/***/ }),
/* 107 */
/*!****************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc0e323"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/ExpandButton.vue ***!
  \****************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "expand-wrap",
    on: {
      "expansion": _vm.handleExpansion
    }
  }, [(_vm.expanded) ? _c('span', {
    staticClass: "expand-wrap--icon expand-wrap--icon__minus"
  }, [_vm._v("−")]) : _c('span', {
    staticClass: "expand-wrap--icon expand-wrap--icon__plus"
  }, [_vm._v("+")])])
},staticRenderFns: []}

/***/ }),
/* 108 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0945bb7e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?sourceMap!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/ui/Expander.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Expander.vue ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Expander.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    triggerElement: {
      type: String,
      required: true
    },
    timing: {
      type: String,
      default: "0.35s"
    },
    easingFunction: {
      type: String,
      default: "ease"
    }
  },
  data: function data() {
    return {
      triggerElementNodes: [],
      show: false
    };
  },

  methods: {
    toggleExpander: function toggleExpander(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      this.show = !this.show;
      var evt = new CustomEvent("expansion", {
        detail: {
          expanded: this.show
        }
      });
      this.triggerElementNodes.forEach(function (node) {
        node.dispatchEvent(evt);
      });
    },
    beforeEnter: function beforeEnter(element) {
      requestAnimationFrame(function () {
        if (!element.style.height) {
          element.style.height = "0px";
        }
        element.style.display = null;
      });
    },
    enter: function enter(element) {
      element.style.transition = "height " + this.timing + " " + this.easingFunction;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          element.style.height = element.scrollHeight + "px";
        });
      });
    },
    afterEnter: function afterEnter(element) {
      element.style.height = null;
      element.style.transition = null;
    },
    beforeLeave: function beforeLeave(element) {
      requestAnimationFrame(function () {
        if (!element.style.height) {
          element.style.height = element.offsetHeight + "px";
        }
      });
    },
    leave: function leave(element) {
      element.style.transition = "height " + this.timing + " " + this.easingFunction;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          element.style.height = "0px";
        });
      });
    },
    afterLeave: function afterLeave(element) {
      element.style.height = null;
      element.style.transition = null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.triggerElementNodes = Array.from(document.querySelectorAll(this.triggerElement));
    this.triggerElementNodes.forEach(function (node) {
      node.addEventListener("click", _this.toggleExpander);
    });
  }
});

/***/ }),
/* 110 */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0945bb7e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Expander.vue ***!
  \************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "expander"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave,
      "after-leave": _vm.afterLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "expanderWrapper",
    staticClass: "expander-wrapper"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 111 */
/*!****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Tooltip.vue ***!
  \****************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Tooltip.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon__ = __webpack_require__(/*! modules/Icon */ 8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Icon__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Modules



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-tooltip',

  components: {
    ModuleLink: __WEBPACK_IMPORTED_MODULE_0_modules_Link___default.a,
    ModuleIcon: __WEBPACK_IMPORTED_MODULE_1_modules_Icon___default.a
  },

  // Props
  props: {
    heading: String,
    close: Boolean,
    level: String,
    tipIcon: String
  },

  // Data
  data: function data() {
    return {
      open: true
    };
  },


  // Methods
  methods: {
    closeTooltip: function closeTooltip() {
      this.open = false;
    }
  }
});

/***/ }),
/* 112 */
/*!***********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019ec19c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Tooltip.vue ***!
  \***********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.open) ? _c('div', {
    class: [
      "tooltip",
      ("tooltip--" + _vm.level)
    ]
  }, [_c('div', {
    staticClass: "tooltip__close"
  }, [(_vm.close) ? _c('module-icon', {
    attrs: {
      "icon": "close"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeTooltip()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tooltip__wrapper"
  }, [(_vm.tipIcon) ? _c('module-icon', {
    attrs: {
      "icon": _vm.tipIcon
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [_vm.tipIcon ? 'ml' : '']
  }, [_vm._t("message")], 2)], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 113 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa08fa0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Form.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: [
      'form',
      {
        'form--wide': _vm.wide,
      } ],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitForm($event)
      }
    }
  }, [_vm._l((_vm.fields), function(field, key) {
    return [((field.heading || {}).heading) ? _c(field.heading.tag || "h3", {
      key: ("fieldset-heading-" + key),
      tag: "component",
      class: [
        "form__field-heading",
        field.heading.level || "h2" ],
      domProps: {
        "innerHTML": _vm._s(field.heading.heading)
      }
    }) : _vm._e(), _vm._v(" "), (field.tooltip) ? _c('div', {
      key: ("tooltip-" + key)
    }, [_c('a', {
      class: [("expand-button-" + key), "link", "link--secondary", "tdn"],
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(field.tooltip.title))]), _vm._v(" "), _c('Expander', {
      attrs: {
        "trigger-element": (".expand-button-" + key)
      }
    }, [_c('ui-tooltip', {
      attrs: {
        "level": "tip",
        "close": false
      }
    }, [_c('template', {
      slot: "message"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(field.tooltip.content)
      }
    })])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), ((field.intro || {}).copy) ? _c('p', {
      key: ("fieldset-intro-" + key),
      class: [
        "form__field-intro",
        field.intro.size || "p",
        {
          'mt0': !!(field.heading || {}).heading,
        } ],
      domProps: {
        "innerHTML": _vm._s(field.intro.copy)
      }
    }) : _vm._e(), _vm._v(" "), _c('module-form-fieldset', {
      key: ("fieldset-" + key),
      attrs: {
        "form-id": _vm.formId,
        "field": field,
        "field-id": key,
        "server-error": _vm.serverErrors[key]
      },
      on: {
        "fieldTouch": function($event) {
          _vm.onFieldTouch(key)
        },
        "fieldReset": function($event) {
          _vm.onFieldReset(key)
        }
      }
    })]
  }), _vm._v(" "), (_vm.serverErrors._global) ? _c('p', {
    class: "form__errors small"
  }, [_vm._v(_vm._s(_vm.serverErrors._global))]) : _vm._e(), _vm._v(" "), _vm._t("before-submit"), _vm._v(" "), (!_vm.noSubmit) ? _c('div', {
    class: [_vm.hideSubmit ? 'visuallyhidden' : 'form__submit']
  }, [_c('module-button', {
    class: [{
      'btn--hidden': _vm.hideSubmit,
    }],
    attrs: {
      "button": _vm.button || '',
      "size": _vm.buttonSize || '',
      "disabled": _vm.$v.$invalid || _vm.invalid,
      "loading": _vm.status.loading,
      "success": _vm.status.success,
      "type": "submit",
      "dark": _vm.buttonDark
    }
  }, [_vm._v("\n      " + _vm._s(_vm.submit || "Submit") + "\n    ")]), _vm._v(" "), _vm._t("submit-extras")], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 114 */
/*!******************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/modules/Logo.vue ***!
  \******************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/modules/Logo.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(/*! config */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_brand_logo_svg_inline__ = __webpack_require__(/*! images/brand/logo.svg?inline */ 115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_images_brand_logo_svg_inline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_images_brand_logo_svg_inline__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_brand_logo_small_svg_inline__ = __webpack_require__(/*! images/brand/logo-small.svg?inline */ 116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_images_brand_logo_small_svg_inline___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_images_brand_logo_small_svg_inline__);
//
//
//
//
//
//
//
//
//
//
//
//
//

// Models


// Images



// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-logo',

  // Props
  props: {
    small: {
      type: Boolean,
      default: false
    }
  },

  // Data
  data: function data() {
    return {
      ImageBrandLogo: __WEBPACK_IMPORTED_MODULE_1_images_brand_logo_svg_inline___default.a,
      ImageBrandLogoSmall: __WEBPACK_IMPORTED_MODULE_2_images_brand_logo_small_svg_inline___default.a
    };
  },

  computed: {
    label: function label() {
      return __WEBPACK_IMPORTED_MODULE_0_config__["a" /* default */].name;
    }
  }
});

/***/ }),
/* 115 */
/*!****************************************************!*\
  !*** ./client/assets/images/brand/logo.svg?inline ***!
  \****************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"221","height":"40","viewBox":"0 0 221 40","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('title',[_v("veritooth-logo-full-color")]),_c('defs',[_c('path',{attrs:{"d":"M2.932 3.006C.991 5.004.02 7.507.02 10.516c0 3.037.99 5.547 2.972 7.532 1.981 1.984 4.554 2.976 7.718 2.976 3.909 0 6.834-1.505 8.775-4.514l-2.951-1.678c-1.197 1.944-3.112 2.916-5.744 2.916-1.888 0-3.477-.493-4.767-1.478-1.29-.986-2.107-2.37-2.453-4.155h16.713c.08-.533.12-1.052.12-1.558 0-2.903-.924-5.387-2.773-7.451C15.782 1.042 13.396.01 10.47.01c-3.084 0-5.597.998-7.538 2.996zm2.912 1.858c1.223-1.052 2.765-1.578 4.627-1.578 1.595 0 2.991.492 4.188 1.478 1.197.985 1.941 2.424 2.234 4.315H3.57c.293-1.758 1.05-3.163 2.274-4.215z","id":"a"}}),_c('path',{attrs:{"d":"M3.487 3.73V.376H.017V20.35h3.47V9.763c0-2.184.612-3.769 1.835-4.754 1.223-.985 2.686-1.438 4.388-1.358V.015c-3.005 0-5.08 1.239-6.223 3.716z","id":"c"}}),_c('path',{attrs:{"d":"M.7.727A2.3 2.3 0 0 0 .02 2.385c0 .639.226 1.185.678 1.638.452.453 1.01.679 1.676.679.638 0 1.183-.226 1.635-.68.452-.452.678-.998.678-1.637A2.3 2.3 0 0 0 4.01.727a2.196 2.196 0 0 0-1.635-.7c-.665 0-1.224.234-1.676.7zM.62 28.313h3.47V8.338H.62v19.975z","id":"e"}}),_c('path',{attrs:{"d":"M3.95 1.067v4.554H0v3.356h3.95v10.827c0 2.477.704 4.162 2.114 5.054 1.409.892 3.63 1.139 6.66.74V22.48c-1.17.053-2.153.073-2.951.06-.798-.013-1.39-.226-1.775-.64-.386-.412-.578-1.111-.578-2.097V8.977h5.305V5.621H7.42V.028L3.95 1.067z","id":"g"}}),_c('path',{attrs:{"d":"M3.072 3.046C1.038 5.07.021 7.56.021 10.516c0 2.957 1.017 5.448 3.051 7.472 2.034 2.024 4.514 3.036 7.44 3.036 2.924 0 5.41-1.012 7.458-3.036s3.071-4.515 3.071-7.471c0-2.957-1.023-5.447-3.071-7.471S13.436.01 10.511.01 5.106 1.022 3.072 3.046zM5.525 15.59c-1.356-1.359-2.034-3.05-2.034-5.074S4.169 6.8 5.525 5.443c1.356-1.358 3.018-2.038 4.986-2.038 1.994 0 3.67.68 5.026 2.038 1.356 1.358 2.034 3.05 2.034 5.074s-.678 3.715-2.034 5.074c-1.356 1.358-3.032 2.037-5.026 2.037-1.968 0-3.63-.679-4.986-2.037z","id":"i"}}),_c('path',{attrs:{"d":"M3.081 3.046C1.047 5.07.03 7.56.03 10.516c0 2.957 1.017 5.448 3.051 7.472 2.034 2.024 4.514 3.036 7.44 3.036 2.924 0 5.41-1.012 7.458-3.036s3.071-4.515 3.071-7.471c0-2.957-1.023-5.447-3.07-7.471C15.931 1.022 13.444.01 10.52.01S5.115 1.022 3.081 3.046zM5.534 15.59C4.178 14.232 3.5 12.54 3.5 10.517S4.178 6.8 5.534 5.443C6.89 4.085 8.552 3.405 10.52 3.405c1.995 0 3.67.68 5.026 2.038 1.356 1.358 2.034 3.05 2.034 5.074s-.678 3.715-2.034 5.074c-1.356 1.358-3.031 2.037-5.026 2.037-1.968 0-3.63-.679-4.986-2.037z","id":"k"}}),_c('path',{attrs:{"d":"M3.961 1.067v4.554H.013v3.356H3.96v10.827c0 2.477.705 4.162 2.114 5.054 1.41.892 3.63 1.139 6.662.74V22.48c-1.17.053-2.154.073-2.952.06-.798-.013-1.39-.226-1.775-.64-.386-.412-.578-1.111-.578-2.097V8.977h5.305V5.621H7.432V.028l-3.47 1.039z","id":"m"}}),_c('path',{attrs:{"d":"M.017.008v27.966h3.47V17.387c0-2.238.532-3.896 1.596-4.974 1.063-1.079 2.46-1.618 4.188-1.618 1.542 0 2.752.446 3.63 1.338.877.892 1.316 2.15 1.316 3.775v12.066h3.47V15.709c0-2.53-.705-4.535-2.114-6.013-1.41-1.478-3.284-2.217-5.624-2.217-2.899 0-5.052 1.132-6.462 3.396V.008H.017z","id":"o"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#003A70","d":"M41.837.03L23.113 35.913 4.388.03H.03l20.848 39.952h4.469L46.195.03z"}}),_c('path',{attrs:{"fill":"#003A70","d":"M8.746.03l5.106 9.785h4.358L13.104.03z"}}),_c('path',{attrs:{"fill":"#003A70","d":"M3.538 4.395h7.486V.03H3.538z"}}),_c('path',{attrs:{"fill":"#00A7B5","d":"M33.122.03l-10.01 19.18-3.193-6.122h-4.363l7.557 14.483L37.48.03zM70.729 11.867l-6.262 16.26-6.263-16.26h-3.75l7.978 19.976h4.069l7.977-19.976z"}}),_c('g',{attrs:{"transform":"translate(75.495 11.339)"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"fill":"#00A7B5","mask":"url(#b)","d":"M-.903 21.949h22.229V-.915H-.903z"}})]),_c('g',{attrs:{"transform":"translate(100.054 11.493)"}},[_c('mask',{attrs:{"id":"d","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#c"}})]),_c('path',{attrs:{"fill":"#00A7B5","mask":"url(#d)","d":"M-.906 21.275h11.539V-.91H-.907z"}})]),_c('g',{attrs:{"transform":"translate(113.088 3.53)"}},[_c('mask',{attrs:{"id":"f","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#e"}})]),_c('path',{attrs:{"fill":"#00A7B5","mask":"url(#f)","d":"M-.902 29.238H5.61V-.897H-.902z"}})]),_c('g',{attrs:{"transform":"translate(121.162 6.246)"}},[_c('mask',{attrs:{"id":"h","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#g"}})]),_c('path',{attrs:{"fill":"#003A70","mask":"url(#h)","d":"M-.923 26.708h14.571V-.897H-.922z"}})]),_c('g',{attrs:{"transform":"translate(135.675 11.339)"}},[_c('mask',{attrs:{"id":"j","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#i"}})]),_c('path',{attrs:{"fill":"#003A70","mask":"url(#j)","d":"M-.902 21.949h22.867V-.915H-.902z"}})]),_c('g',{attrs:{"transform":"translate(158.57 11.339)"}},[_c('mask',{attrs:{"id":"l","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#k"}})]),_c('path',{attrs:{"fill":"#003A70","mask":"url(#l)","d":"M-.893 21.949h22.867V-.915H-.893z"}})]),_c('g',{attrs:{"transform":"translate(180.849 6.246)"}},[_c('mask',{attrs:{"id":"n","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#m"}})]),_c('path',{attrs:{"fill":"#003A70","mask":"url(#n)","d":"M-.91 26.708h14.57V-.897H-.91z"}})]),_c('g',{attrs:{"transform":"translate(197.612 3.87)"}},[_c('mask',{attrs:{"id":"p","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#o"}})]),_c('path',{attrs:{"fill":"#003A70","mask":"url(#p)","d":"M-.906 28.899H18.61V-.917H-.906z"}})]),_c('path',{attrs:{"d":"M220.504 28.645l-.95 1.52-.95-1.52h-.468v2.84h.468v-2.03l.921 1.477h.057l.922-1.477v2.03h.468v-2.84h-.468zm-4.892 0v.44h.836v2.4h.468v-2.4h.837v-.44h-2.141z","fill":"#003A70"}})])])}}};

/***/ }),
/* 116 */
/*!**********************************************************!*\
  !*** ./client/assets/images/brand/logo-small.svg?inline ***!
  \**********************************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports = {render: function () {with(this){return _c('svg',{attrs:{"width":"500","height":"432","viewBox":"0 0 500 432","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',[_v("veritooth-mark")]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#003A70","d":"M452.8.001L250 388.004 47.2.001H0l225.799 432H274.2L500 .001z"}}),_c('path',{attrs:{"fill":"#003A70","d":"M94.4.001l55.301 105.802 47.201.003L141.6.001z"}}),_c('path',{attrs:{"fill":"#003A70","d":"M38 47.202h81.08V.001H38z"}}),_c('path',{attrs:{"fill":"#00A7B5","d":"M358.404.001L250 207.404l-34.589-66.203-47.25-.007 81.84 156.607L405.605.001z"}}),_c('path',{attrs:{"d":"M497.025 60.515v15.601h-2.574V64.961l-5.07 8.113h-.313l-5.07-8.113v11.155h-2.575v-15.6h2.575l5.226 8.345 5.227-8.346h2.574zm-17.707 2.418h-4.603v13.183h-2.574V62.933h-4.6v-2.418h11.777v2.418z","fill":"#003A70"}})])])}}};

/***/ }),
/* 117 */
/*!*************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478305f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Logo.vue ***!
  \*************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    class: [
      'logo' ]
  }, [_c('span', {
    staticClass: "logo__inner"
  }, [_c(_vm.small ? _vm.ImageBrandLogoSmall : _vm.ImageBrandLogo, {
    tag: "component",
    staticClass: "logo__image"
  }), _vm._v(" "), _c('span', {
    staticClass: "visuallyhidden"
  }, [_vm._v(_vm._s(_vm.label))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 118 */
/*!********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33153b5f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Auth.vue ***!
  \********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "auth",
      ("auth--" + _vm.slug),
      "group",
      "group--first-last" ]
  }, [(_vm.titleSet !== null) ? _c(_vm.modal ? "h2" : "h1", {
    tag: "tag",
    class: [
      "mt0",
      _vm.modal ? "h3" : "h2",
      {
        'mt0': _vm.modal,
      }
    ]
  }, [_vm._v(_vm._s(_vm.titleSet))]) : _vm._e(), _vm._v(" "), (_vm.copySet) ? _c('p', {
    staticClass: "p tc",
    domProps: {
      "innerHTML": _vm._s(_vm.successCopy && _vm.status.success ? _vm.successCopy : _vm.copySet)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("top-link"), _vm._v(" "), (_vm.slug === "login") ? _c('p', {
    staticClass: "p small"
  }, [_vm._v("Haven't got an account? "), _c('module-link', {
    attrs: {
      "link": "register-patient"
    }
  }, [_vm._v("Sign Up")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.successCopy || (_vm.successCopy && !_vm.status.success)),
      expression: "!successCopy || (successCopy && !status.success)"
    }]
  }, [_c('module-form', {
    class: [
      "auth__form",
      ("auth__form--" + _vm.slug) ],
    attrs: {
      "form-id": _vm.formId,
      "fields": _vm.fields[_vm.slug],
      "action": _vm.requestAction,
      "success": _vm.success,
      "fail": _vm.fail,
      "submit": _vm.submitSet,
      "button-size": "m",
      "button": "primary"
    }
  }, [_c('div', {
    staticClass: "form__before-button",
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_vm._t("before-submit")], 2)])], 1), _vm._v(" "), (_vm.hasFooter) ? _c('p', {
    staticClass: "auth__footer small tc"
  }, [_vm._t("link")], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 119 */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6eff5fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Modal.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "modal",
      ("modal--" + _vm.id),
      "cover--fixed",
      {
        'modal--active': _vm.active,
        'modal--auth': _vm.auth,
        'modal--auto': _vm.auto,
      } ]
  }, [_c('div', {
    staticClass: "modal__bg cover",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal__wrapper"
  }, [(_vm.hasHeader) ? _c('div', {
    staticClass: "modal__header"
  }, [(!_vm.noClose) ? _c('module-modal-close') : _vm._e(), _vm._v(" "), _vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c('div', {
    staticClass: "modal__inner"
  }, [(!_vm.hasHeader && !_vm.noClose) ? [_c('module-modal-close'), _vm._v(" "), _c('span', {
    staticClass: "modal__float",
    attrs: {
      "aria-hidden": "true"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.visible) ? [(_vm.auth) ? _c('ui-auth', {
    attrs: {
      "slug": _vm.auth,
      "modal": true,
      "success": function () {
        _vm.closeModal();
      }
    }
  }) : _vm._t("default")] : _vm._e()], 2)]), _vm._v(" "), (_vm.hasFooter) ? _c('div', {
    staticClass: "modal__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 120 */
/*!*****************************************!*\
  !*** ./client/components/ui/Header.vue ***!
  \*****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Header.vue */ 121),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-00a1fa04"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Header.vue */ 128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/*!***************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Header.vue ***!
  \***************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Header.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_config__ = __webpack_require__(/*! config */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_services_scroll__ = __webpack_require__(/*! services/scroll */ 18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Logo__ = __webpack_require__(/*! modules/Logo */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_Logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modules_Logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_modules_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ui_Navigation__ = __webpack_require__(/*! ui/Navigation */ 122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ui_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_ui_Navigation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// Vue/Vuex


// Services


// Modules



// Ui


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ui-header',

  // Components
  components: {
    ModuleLogo: __WEBPACK_IMPORTED_MODULE_3_modules_Logo___default.a,
    UiNavigation: __WEBPACK_IMPORTED_MODULE_5_ui_Navigation___default.a,
    ModuleLink: __WEBPACK_IMPORTED_MODULE_4_modules_Link___default.a
  },

  // Data
  data: function data() {
    return {
      fixed: false,
      headerLinks: []
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated']), {
    wpUrl: function wpUrl() {
      return __WEBPACK_IMPORTED_MODULE_0_config__["a" /* default */].wp;
    },
    page: function page() {
      return this.$store.state.app.page;
    },
    loading: function loading() {
      return this.$store.state.app.state.loading;
    }
  }),

  // Lifecycle
  mounted: function mounted() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_2_services_scroll__["a" /* createScroll */])('header', {
      el: this.$el,
      move: function move(e) {
        if (e.scrollY > 0 && _this.fixed === false) _this.fixed = true;else if (e.scrollY <= 0 && _this.fixed === true) _this.fixed = false;
      }
    });
  },
  destroyed: function destroyed() {
    Object(__WEBPACK_IMPORTED_MODULE_2_services_scroll__["b" /* destroyScroll */])('header');
  }
});

/***/ }),
/* 122 */
/*!*********************************************!*\
  !*** ./client/components/ui/Navigation.vue ***!
  \*********************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Navigation.vue */ 123),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-64bf3e8b"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Navigation.vue */ 127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/*!*******************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Navigation.vue + 1 modules ***!
  \*******************************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/Navigation.vue (referenced with cjs require) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/services/array.js because of ./client/index.js */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Button.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Icon.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/modules/Link.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./client/components/ui/UserInfo.vue (<- Module is not an ECMAScript module) */
/*! ModuleConcatenation bailout: Cannot concat with ./node_modules/vuex/dist/vuex.esm.js */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(5);

// EXTERNAL MODULE: ./client/services/array.js
var array = __webpack_require__(2);

// CONCATENATED MODULE: ./client/models/global/menu.js


/* harmony default export */ var menu = ([{
  name: 'Home',
  model: 'Home',
  id: 1,
  path: 'home'
}]);
// EXTERNAL MODULE: ./client/components/modules/Button.vue
var Button = __webpack_require__(10);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

// EXTERNAL MODULE: ./client/components/modules/Link.vue
var Link = __webpack_require__(7);
var Link_default = /*#__PURE__*/__webpack_require__.n(Link);

// EXTERNAL MODULE: ./client/components/modules/Icon.vue
var Icon = __webpack_require__(8);
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);

// EXTERNAL MODULE: ./client/components/ui/UserInfo.vue
var UserInfo = __webpack_require__(124);
var UserInfo_default = /*#__PURE__*/__webpack_require__.n(UserInfo);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/Navigation.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Services


// Models


// Modules




// Ui


// Export
/* harmony default export */ var Navigation = __webpack_exports__["default"] = ({
  name: 'ui-navigation',

  // Components
  components: {
    ModuleLink: Link_default.a,
    ModuleButton: Button_default.a,
    ModuleIcon: Icon_default.a,
    UiUserInfo: UserInfo_default.a
  },

  // Data
  data: function data() {
    return {
      menus: menu,
      headerLinks: []
    };
  },

  computed: Object.assign({}, Object(vuex_esm["c" /* mapGetters */])('auth', ['isAuthenticated', 'user', 'userRole', 'userIsRole']), {
    signin: function signin() {
      var signupRoutes = ['register-patient', 'register-dentist', 'login', 'logout', 'register', 'set-password', 'authReset', 'authConfirm'];
      return Object(array["a" /* arrayIncludes */])(signupRoutes, this.$route.name);
    }
  }),

  // Methods
  methods: Object.assign({}, Object(vuex_esm["b" /* mapActions */])('modals', ['openModal']), Object(vuex_esm["b" /* mapActions */])('dashboard', ['toggleDashboard']))
});

/***/ }),
/* 124 */
/*!*******************************************!*\
  !*** ./client/components/ui/UserInfo.vue ***!
  \*******************************************/
/*! dynamic exports provided */
/*! exports used: default */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 0)(
  /* script */
  __webpack_require__(/*! !babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./UserInfo.vue */ 125),
  /* template */
  __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-04497cd0"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserInfo.vue */ 126),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./client/components/ui/UserInfo.vue ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is referenced from these modules with unsupported syntax: ./client/components/ui/UserInfo.vue (referenced with cjs require) */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Link__ = __webpack_require__(/*! modules/Link */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_modules_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_modules_Link__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Vuex


// Modules


// Export
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-user-info',

  // Components
  components: {
    ModuleLink: __WEBPACK_IMPORTED_MODULE_1_modules_Link___default.a
  },

  // Data
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])('auth', ['isAuthenticated', 'user', 'userRole']))
});

/***/ }),
/* 126 */
/*!************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04497cd0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/UserInfo.vue ***!
  \************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-link', {
    staticClass: "u-user-info",
    attrs: {
      "link": "dashboard",
      "no-underline": true
    }
  }, [_c('span', {
    staticClass: "u-user-info__wrapper"
  }, [_c('span', {
    staticClass: "u-user-info__name p"
  }, [_vm._v(_vm._s(_vm.user.full_name || ""))]), _vm._v(" "), _c('span', {
    staticClass: "u-user-info__role h6"
  }, [_vm._v(_vm._s(_vm.userRole.string || ""))])])])
},staticRenderFns: []}

/***/ }),
/* 127 */
/*!**************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bf3e8b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Navigation.vue ***!
  \**************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "p navigation"
  }, [_c('div', {
    staticClass: "navigation__cta"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('span', {
    staticClass: "header__links header__links--desktop"
  }, _vm._l((_vm.headerLinks), function(headerLink) {
    return _c('module-link', {
      key: headerLink.name,
      staticClass: "header__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": headerLink.name,
        "label": headerLink.label,
        "external": false
      }
    })
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isAuthenticated && !_vm.signin) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Sign In"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openModal("login")
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('ui-user-info') : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 128 */
/*!**********************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00a1fa04"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Header.vue ***!
  \**********************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: [
      'header',
      {
        'header--fixed': _vm.fixed,
      } ]
  }, [_c('b', {
    class: [
      "header__bg",
      {
        'header__bg--fixed': _vm.fixed,
      } ]
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [(!_vm.isAuthenticated) ? _c('a', {
    staticClass: "header__logo",
    attrs: {
      "href": _vm.wpUrl
    }
  }, [_c('module-logo')], 1) : _c('router-link', {
    class: "header__logo",
    attrs: {
      "to": {
        name: "dashboard"
      }
    }
  }, [_c('module-logo')], 1), _vm._v(" "), _c('ui-navigation')], 1), _vm._v(" "), (!_vm.isAuthenticated) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "mobile-menu"
  }, [_c('span', {
    staticClass: "header__links"
  }, _vm._l((_vm.headerLinks), function(headerLink) {
    return _c('module-link', {
      key: headerLink.name,
      staticClass: "header__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": headerLink.name,
        "label": headerLink.label,
        "external": false
      }
    })
  }))])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 129 */
/*!****************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63713ffd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/App.vue ***!
  \****************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "page",
      _vm.appPage.classes,
      {
        'page--is-loaded': _vm.appState.loaded,
      } ],
    attrs: {
      "id": "app",
      "data-env": _vm.appEnv
    }
  }, [_c('ui-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "loader",
      "mode": "out-in"
    },
    on: {
      "appear": function($event) {
        _vm.onLoad()
      },
      "enter": function($event) {
        _vm.onLoad()
      },
      "leave": function($event) {
        _vm.onLeave()
      }
    }
  }, [_c('router-view', {
    key: _vm.$route.meta.key || _vm.$route.fullPath
  })], 1), _vm._v(" "), _c('module-modal', {
    attrs: {
      "id": "login",
      "auto": true,
      "no-close": true,
      "auth": "login"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/*!*********************!*\
  !*** got (ignored) ***!
  \*********************/
/*! dynamic exports provided */
/*! all exports used */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[51]);


// WEBPACK FOOTER //
// assets/client.6b095df0.js